export const resources = {
  en: {
    translation: {
      common: {
        loading: "Loading...",
        menu: "Menu",
        dashboard: "Dashboard",
        myProfile: "My Profile",
        adminPanel: "Admin Panel",
        projects: "Projects",
        publications: "Publications",
        announcements: "Announcements",
        messages: "Messages",
        matching: "Matching",
        autoMatching: "Auto Matching",
        connections: "Connections",
        requests: "Requests",
        logout: "Logout",
        language: "Language",
        view: "View",
        manage: "Manage",
        editProfile: "Edit profile",
        close: "Close",
        message: "Message",
        refresh: "Refresh",
        search: "Search",
        reset: "Reset",
        previous: "Prev",
        next: "Next",
        any: "Any",
        yes: "Yes",
        no: "No",
        connect: "Connect",
        connected: "Connected",
        pending: "Pending",
        send: "Send",
        sending: "Sending...",
        upload: "Upload",
        replace: "Replace",
        open: "Open",
        remove: "Remove",
        add: "Add",
        edit: "Edit",
        delete: "Delete",
        cancel: "Cancel",
        save: "Save",
        create: "Create",
        details: "Details",
        profile: "Profile",
        pdf: "PDF",
        link: "Link",
        searching: "Searching...",
        unknownUser: "Unknown user",
        description: "Description",
        title: "Title",
        website: "Website",
        linkedin: "LinkedIn",
        github: "GitHub",
        or: "OR",
        orContinueWith: "OR CONTINUE WITH"
      },
      theme: {
        day: "Day",
        night: "Night",
        switchToLight: "Switch to light mode",
        switchToDark: "Switch to dark mode"
      },
      brand: {
        name: "Youngreenteco",
        tagline: "Connect & Grow"
      },
      sections: {
        admin: "Admin",
        explore: "Explore"
      },
      roles: {
        ADMIN: "Administrator",
        SUPERVISOR: "Supervisor",
        ENTREPRENEURS: "Entrepreneurs",
        MENTORS: "Mentors",
        INVESTORS: "Investors",
        MANUFACTURERS: "Manufacturers"
      },
      layout: {
        defaultTitle: "Page",
        dashboardSubtitle: "Overview and suggestions",
        adminSubtitle: "Manage platform accounts",
        openMenu: "Open menu"
      },
      home: {
        hero: {
          line1: "European Network",
          line2: "of Young Green",
          line3: "Entrepreneurs."
        },
        subtitle: "Connect entrepreneurs, mentors, investors and manufacturers in one place.",
        welcome: "Welcome",
        choosePath: "Choose where you want to go.",
        loginTitle: "Log in",
        loginText: "Access your workspace",
        registerTitle: "Register",
        registerText: "Create a new account",
        partners: "This platform was built with the support of our partners.",
        contact: "For questions, contact:"
      },
      login: {
        title: "Welcome Back",
        subtitle: "Enter your credentials to access your workspace",
        emailLabel: "Email Address",
        emailPlaceholder: "name@example.com",
        passwordLabel: "Password",
        signIn: "Log In",
        signingIn: "Signing in...",
        registerPrompt: "Do not have an account?",
        registerNow: "Register now",
        googleFailed: "Google authentication failed. Please try again.",
        errors: {
          invalidCredentials: "Invalid email or password.",
          loginFailed: "Login failed. Please try again.",
          unexpected: "An unexpected error occurred. Please try again."
        },
        features: {
          entrepreneursTitle: "Entrepreneurs",
          entrepreneursText: "Connect with mentors, investors, and manufacturers aligned with your growth stage.",
          mentorsTitle: "Mentors",
          mentorsText: "Support founders with targeted expertise and structured guidance.",
          investorsTitle: "Investors",
          investorsText: "Discover curated startups by sector, traction, and readiness.",
          manufacturersTitle: "Manufacturers",
          manufacturersText: "Collaborate with startups ready for prototyping and production."
        }
      },
      register: {
        platformTitle: "European Network of Young Green Entrepreneurs",
        platformSubtitle: "Younggreenteco Ecosystem Platform",
        chooseRole: "Choose your role",
        basicInfo: "Basic information",
        firstName: "First name",
        lastName: "Last name",
        email: "Email",
        password: "Password",
        createAccount: "Create Account",
        alreadyHaveAccount: "Already have an account?",
        logIn: "Log in",
        continueWithGoogle: "Select a role to continue with Google",
        alerts: {
          selectRoleFirst: "Please select a role before continuing with Google",
          googleFailed: "Google registration failed",
          authFailed: "Google authentication failed"
        },
        errors: {
          selectRole: "Please select a role",
          invalidEmail: "Invalid email address",
          passwordUppercase: "Password must contain at least one uppercase letter",
          passwordBang: "Password must contain the ! character",
          registrationFailed: "Registration failed. Please try again."
        }
      },
      dashboard: {
        loading: "Loading dashboard...",
        welcome: "Welcome back, {{name}}",
        intro: "Quick overview of your activity and platform features.",
        overview: "Overview",
        upToDate: "Up to date",
        quickGuide: "Quick Guide",
        quickGuideSubtitle: "How the platform works",
        stats: {
          connections: "Connections",
          connectionsHint: "People you are connected with",
          projects: "Projects",
          projectsHint: "Your created projects",
          publications: "Publications",
          publicationsHint: "Your published work"
        },
        steps: {
          profileTitle: "Complete your profile",
          profileText: "A detailed profile improves matching and visibility.",
          usersTitle: "Find compatible users",
          usersText: "Use Matching or Auto-matching to discover relevant people.",
          connectionsTitle: "Build connections",
          connectionsText: "Send requests, accept invitations, and collaborate.",
          projectsTitle: "Create projects",
          projectsText: "Add projects to showcase your work and attract collaborators.",
          publicationsTitle: "Add publications",
          publicationsText: "Share research outputs and upload related documents."
        }
      },
      profile: {
        loading: "Loading profile...",
        title: "My Profile",
        subtitle: "Update your profile details and preferences. Changes are saved automatically.",
        saveChanges: "Save Changes",
        savingButton: "Saving...",
        saveAutomatic: "Saving automatically...",
        saveError: "Auto-save failed",
        savePending: "Unsaved changes...",
        saveComplete: "All changes saved",
        savedAt: "Saved automatically at {{time}}",
        saved: "Profile saved.",
        saveFailed: "Profile save failed.",
        autosaveFailedLocal: "Auto-save failed. Changes are still only local.",
        uploadingPhoto: "Uploading photo...",
        photoUpdated: "Profile photo updated.",
        photoFailed: "Photo upload failed.",
        uploadingCv: "Uploading CV...",
        cvUploaded: "CV uploaded.",
        cvFailed: "CV upload failed.",
        cvOpenFailed: "Could not open CV.",
        header: "Profile overview",
        headerTip: "Your avatar and a quick profile strength indicator.",
        details: "Profile details",
        detailsTip: "Basic info shown publicly: headline, bio, location, affiliation, profession and faculty.",
        collaboration: "Collaboration",
        collaborationTip: "Availability, experience level and collaboration preferences.",
        expertise: "Expertise",
        expertiseTip: "Add expert areas and a short description so people understand your skills.",
        resources: "Labs / Resources",
        resourcesTip: "Optional links to labs, tools, repositories, papers or datasets.",
        companies: "Companies",
        companiesTip: "Add one or more companies and their domains. You can leave it blank.",
        links: "External links",
        linksTip: "Add links (LinkedIn, GitHub, website) so others can view your work.",
        profileStrength: "Profile strength",
        professionalHeadline: "Your professional headline",
        uploadProfilePhotoAria: "Upload profile photo",
        openProfilePhotoAria: "Uploading profile photo",
        changePhoto: "Change photo",
        uploadPhoto: "Upload photo",
        uploading: "Uploading...",
        imageUploading: "Image upload in progress...",
        imageRecommended: "PNG, JPG or WEBP recommended.",
        replaceCv: "Replace CV",
        uploadCv: "Upload CV",
        viewCv: "View CV",
        noCv: "No CV uploaded",
        cvReady: "CV uploaded and ready to view.",
        documentUploading: "Document upload in progress...",
        headline: "Headline",
        bio: "Bio",
        bioPlaceholder: "Add all the relevant details you want about your background, expertise, projects, publications and collaboration goals.",
        charactersLeft: "{{count}} characters left",
        country: "Country",
        city: "City",
        affiliation: "Affiliation",
        profession: "Profession",
        university: "University",
        availability: "Availability",
        experienceLevel: "Experience level",
        fullTime: "Full time",
        partTime: "Part time",
        weekends: "Weekends",
        junior: "Junior",
        mid: "Mid",
        senior: "Senior",
        openToProjects: "Open to projects",
        openToMentoring: "Open to mentoring",
        addExpertiseHint: "Add at least one area so others can find you.",
        expertArea: "Expert area",
        expertAreaPlaceholder: "Search or add an expert area",
        addExpertise: "+ Add expertise",
        resourceHint: "Optional: add links to labs, tools, papers, or repositories.",
        resourceUrl: "URL",
        addResource: "+ Add resource",
        companyHint: "Optional: add a company if you represent an organization.",
        companyName: "Company name",
        companyDescription: "Company description",
        domains: "Domains",
        addCompany: "+ Add company"
      },
      picker: {
        searchOrAdd: "Search or add...",
        pressEnterToAdd: "Press Enter to add if it is not in the list."
      },
      accountSettings: {
        title: "Account Settings",
        cooldown: "You can change your name again after: {{date}}",
        firstName: "First name",
        lastName: "Last name",
        cancel: "Cancel",
        save: "Save",
        saving: "Saving...",
        saved: "Saved.",
        taken: "This name is already taken. Please use a different first + last name.",
        cooldownError: "You can change your name again after the 14-day cooldown.",
        invalid: "Invalid name.",
        genericError: "Something went wrong. Please try again."
      },
      profileModal: {
        title: "Profile",
        profession: "Profession",
        faculty: "Faculty",
        university: "University",
        bio: "Bio",
        collaborations: "Collaborations",
        expertise: "Expertise",
        resources: "Resources",
        companies: "Companies",
        cv: "CV",
        openCv: "Open CV",
        links: "Links"
      },
      matching: {
        loadFailed: "Could not load profiles.",
        profileLoadFailed: "Could not load profile.",
        conversationFailed: "Could not start conversation.",
        title: "Matching",
        subtitle: "Browse profiles and filter by expertise and availability.",
        sortBy: "Sort by",
        sortName: "Name",
        sortExpertise: "Expertise area",
        sortAvailability: "Availability",
        sortProjects: "Open to projects",
        sortMentoring: "Open to mentoring",
        sortExperience: "Experience level",
        asc: "Asc",
        desc: "Desc",
        filterName: "Name",
        searchByName: "Search by name",
        filterExpertise: "Expertise area",
        expertisePlaceholder: "Expertise area",
        filterAvailability: "Availability",
        filterExperience: "Experience",
        filterProjects: "Open to projects",
        filterMentoring: "Open to mentoring",
        empty: "No matching profiles.",
        viewProfile: "View profile",
        requested: "Requested",
        reviewRequest: "Review request",
        requestSent: "Request sent.",
        requestFailed: "Could not send request.",
        openProfile: "Open profile",
        pageSummary: "Page {{page}} / {{total}} Â· {{count}} profiles"
      },
      autoMatching: {
        loadFailed: "Could not load auto-matches.",
        profileLoadFailed: "Could not load profile.",
        conversationFailed: "Could not start conversation.",
        requestSent: "Connection request sent.",
        requestFailed: "Could not send connection request.",
        title: "Auto Matching",
        subtitle: "Review your strongest automatic matches and connect faster.",
        empty: "No results.",
        whyMatch: "Why you match",
        noDetails: "No matching details available.",
        affiliation: "Affiliation",
        experience: "Experience",
        expertise: "Expertise",
        collaboration: "Collaboration",
        bio: "Bio",
        totalScore: "Total score",
        unknown: "Unknown",
        profileButton: "Profile",
        slideAria: "Go to slide {{index}}",
        previous: "Previous",
        next: "Next"
      },
      connectionRequests: {
        loadFailed: "Could not load requests.",
        acceptFailed: "Could not accept request.",
        rejectFailed: "Could not reject request.",
        title: "Connection requests",
        subtitle: "Here you can accept or reject connection requests. To send a new request, go to Matching or open a profile.",
        empty: "No pending requests. If you want to connect with someone, go to Matching and send a request.",
        accept: "Accept",
        reject: "Reject",
        user: "User"
      },
      connections: {
        title: "Connections",
        subtitle: "People you are connected with. From here you can open profiles or start a conversation.",
        empty: "No connections yet. Go to Matching to discover people and send connection requests.",
        loadFailed: "Could not load connections.",
        profileLoadFailed: "Could not load profile.",
        conversationFailed: "Could not start conversation."
      },
      announcements: {
        title: "Announcements",
        subtitle: "Updates from people and projects, newest first.",
        refreshing: "Refreshing...",
        composerPlaceholder: "Share an update...",
        previewAlt: "Preview image",
        removeImage: "Remove image",
        attachPhoto: "Attach a photo",
        photo: "Photo",
        postUpdate: "Post update",
        uploading: "Uploading...",
        posting: "Posting...",
        post: "Post",
        loadMore: "Load more",
        loadFailed: "Failed to load announcements.",
        profileLoadFailed: "Could not load profile.",
        imageFileOnly: "Please choose an image file.",
        imageTooLarge: "Image is too large (max 8 MB).",
        posted: "Posted.",
        postFailed: "Failed to post.",
        commentAdded: "Comment added.",
        commentFailed: "Failed to comment.",
        commentDeleted: "Comment deleted.",
        commentDeleteFailed: "Failed to delete comment.",
        deleteFallback: "this post",
        deleted: "Post deleted.",
        deleteFailed: "Failed to delete post.",
        conversationFailed: "Could not start conversation.",
        deleteTitle: "Delete post",
        deleteMessage: "Delete \"{{title}}\"? This can't be undone.",
        deleting: "Deleting...",
        deletePost: "Delete post",
        deleteComment: "Delete comment",
        postImageAlt: "Post image",
        likesCount: "{{count}} likes",
        commentsCount: "{{count}} comments",
        like: "Like",
        comment: "Comment",
        commentPlaceholder: "Write a comment..."
      },
      adminUsers: {
        usersLoadFailed: "Users could not be loaded.",
        userUpdated: "User details were updated.",
        userUpdateFailed: "User details could not be updated.",
        userDeleted: "User account was deleted.",
        userDeleteFailed: "User could not be deleted.",
        eyebrow: "Administrator tools",
        title: "User management",
        subtitle: "Access is limited to accounts with backend role ADMIN. Supervisors can manage administrator accounts. Administrators can manage only standard users.",
        totalUsers: "Total users",
        adminAccounts: "Admin accounts",
        projects: "Projects",
        publications: "Publications",
        announcements: "Announcements",
        pendingRequests: "Pending requests",
        roleBreakdown: "Role breakdown",
        activeRoles: "{{count}} active roles",
        usersCount: "{{count}} users",
        searchUsers: "Search users",
        searchPlaceholder: "Name or email",
        currentAccount: "Current account: {{name}}",
        loadingUsers: "Loading users...",
        noUsers: "No users matched your search.",
        currentAccountBadge: "Current account",
        userId: "User ID #{{id}}",
        selfLocked: "Your own admin account is locked in this panel so the current session stays valid.",
        supervisorProtected: "Supervisor accounts are protected and must be managed manually outside this panel.",
        adminRestricted: "Administrators cannot manage administrator or supervisor accounts.",
        firstName: "First name",
        lastName: "Last name",
        email: "Email",
        role: "Role",
        saveChanges: "Save changes",
        deleteTitle: "Delete user account?",
        deleteMessage: "You are about to remove {{name}}. This also removes related profile data, projects, publications, messages, and announcements.",
        deleting: "Deleting...",
        deletePermanently: "Delete permanently",
        roles: {
          citizen: "Citizen",
          entrepreneurs: "Entrepreneurs",
          mentors: "Mentors",
          investors: "Investors",
          manufacturers: "Manufacturers",
          admin: "Administrator",
          supervisor: "Supervisor"
        }
      },
      messagesPage: {
        conversationsLoadFailed: "Could not load conversations.",
        messagesLoadFailed: "Could not load messages.",
        pdfOnly: "Only PDF files are allowed.",
        pdfTooLarge: "PDF too large (max 25MB).",
        sendFailed: "Failed to send message.",
        downloadFailed: "Failed to download attachment.",
        removedToast: "Conversation with {{name}} removed from your list.",
        removeFailed: "Could not remove conversation.",
        title: "Messaging",
        subtitle: "Your conversations. If you have no messages, start by connecting with someone.",
        searchPlaceholder: "Search...",
        noResults: "No results.",
        noConversations: "No conversations yet. Go to Connections and start a message.",
        selectConversation: "Select a conversation",
        chooseConversation: "Choose a conversation to start chatting.",
        selectFromLeft: "Select a conversation from the left, or go to Connections to start one.",
        loadingMessages: "Loading messages...",
        you: "You",
        openPdf: "Open PDF",
        attachPdf: "Attach PDF",
        pdfOptional: "PDF optional",
        writeMessage: "Write a message...",
        selectConversationFirst: "Select a conversation first",
        removeTitle: "Remove conversation",
        removeMessage: "Remove conversation with \"{{name}}\" from your list?"
      },
      projects: {
        title: "Projects",
        subtitle: "Create your projects and explore projects published by others.",
        myProjects: "My projects",
        exploreProjects: "Explore projects",
        explore: "Explore",
        newProject: "+ New project",
        addProject: "Add project",
        acronym: "Acronym",
        searchPlaceholder: "Search...",
        noProjectsYet: "No projects yet.",
        noProjects: "No projects.",
        abstract: "Abstract",
        timeline: "Timeline:",
        extension: "Ext:",
        startDate: "Start date",
        endDate: "End date",
        extensionEnd: "Possible extension end",
        contractNumber: "Contract number",
        coordinator: "Coordinator",
        partners: "Partners",
        partner: "Partner",
        addPartner: "Add partner",
        removePartner: "Remove partner",
        deleteTitle: "Delete project",
        deleteMessage: "Delete \"{{title}}\"? This can't be undone.",
        deleting: "Deleting...",
        loadProfileFailed: "Failed to load profile.",
        viewProfile: "View profile"
      },
      publications: {
        title: "Publications",
        subtitle: "Add your publications and explore publications published by others.",
        myPublications: "My publications",
        explore: "Explore",
        newPublication: "+ New publication",
        searchPublications: "Search publications",
        searchPlaceholder: "Search by title, authors, journal, DOI, user...",
        noPublicationsYet: "No publications yet.",
        noResults: "No results.",
        type: "Type",
        publicationTitle: "Title",
        publicationTitlePlaceholder: "Publication title",
        authors: "Authors",
        externalLink: "External link",
        publicationDate: "Publication date",
        year: "Year",
        keywords: "Keywords",
        journalConferenceTitle: "Journal / Conference title",
        journalConference: "Journal / Conference",
        volumeIssue: "Volume / issue",
        pages: "Pages",
        doi: "DOI",
        publisher: "Publisher",
        pdfUpload: "PDF (max 10 MB)",
        replacePdf: "Replace PDF (max 10 MB)",
        openCurrentPdf: "Open current PDF",
        saved: "Publication saved.",
        saveFailed: "Could not save the publication.",
        updated: "Publication updated.",
        updateFailed: "Could not update the publication.",
        deleted: "Publication deleted.",
        deleteFailed: "Could not delete the publication.",
        openPdfFailed: "Could not open PDF.",
        loadFailed: "Could not load publications.",
        profileLoadFailed: "Could not load profile.",
        conversationFailed: "Could not start conversation.",
        deleteTitle: "Delete publication",
        deleteAdminTitle: "Delete publication (admin)",
        deleteMessage: "Delete \"{{title}}\"? This can't be undone.",
        deleting: "Deleting...",
        titleRequired: "Title is required.",
        yearInvalid: "Year must be between 1900 and 2100.",
        dateRequired: "Publication date is required.",
        publisherRequired: "Publisher is required for books/chapters.",
        journalRequired: "Journal / Conference title is required.",
        pdfTooLarge: "PDF must be max 10 MB.",
        pdfOnly: "Only PDF files are allowed.",
        typeJournalArticle: "Journal Article",
        typeConferencePaper: "Conference Paper",
        typeBook: "Book",
        typeBookChapter: "Book Chapter"
      }
    }
  },
  ro: {
    translation: {
      common: {
        loading: "Se incarca...",
        menu: "Meniu",
        dashboard: "Panou",
        myProfile: "Profilul meu",
        adminPanel: "Panou admin",
        projects: "Proiecte",
        publications: "Publicatii",
        announcements: "Anunturi",
        messages: "Mesaje",
        matching: "Potriviri",
        autoMatching: "Potrivire automata",
        connections: "Conexiuni",
        requests: "Cereri",
        logout: "Deconectare",
        language: "Limba",
        view: "Vezi",
        manage: "Administreaza",
        editProfile: "Editeaza profilul",
        close: "Inchide",
        message: "Mesaj",
        refresh: "Reimprospateaza",
        search: "Cauta",
        reset: "Reseteaza",
        previous: "Inapoi",
        next: "Inainte",
        any: "Oricare",
        yes: "Da",
        no: "Nu",
        connect: "Conecteaza",
        connected: "Conectat",
        pending: "In asteptare",
        send: "Trimite",
        sending: "Se trimite...",
        upload: "Incarca",
        replace: "Inlocuieste",
        open: "Deschide",
        remove: "Sterge",
        add: "Adauga",
        edit: "Editeaza",
        delete: "Sterge",
        cancel: "Anuleaza",
        save: "Salveaza",
        create: "Creeaza",
        details: "Detalii",
        profile: "Profil",
        pdf: "PDF",
        link: "Link",
        searching: "Se cauta...",
        unknownUser: "Utilizator necunoscut",
        description: "Descriere",
        title: "Titlu",
        website: "Website",
        linkedin: "LinkedIn",
        github: "GitHub",
        or: "SAU",
        orContinueWith: "SAU CONTINUA CU"
      },
      theme: {
        day: "Zi",
        night: "Noapte",
        switchToLight: "Comuta pe modul luminos",
        switchToDark: "Comuta pe modul intunecat"
      },
      brand: {
        name: "Youngreenteco",
        tagline: "Conecteaza-te si creste"
      },
      sections: {
        admin: "Administrare",
        explore: "Exploreaza"
      },
      roles: {
        ADMIN: "Administrator",
        SUPERVISOR: "Supervizor",
        ENTREPRENEURS: "Antreprenori",
        MENTORS: "Mentori",
        INVESTORS: "Investitori",
        MANUFACTURERS: "Producatori"
      },
      layout: {
        defaultTitle: "Pagina",
        dashboardSubtitle: "Privire de ansamblu si sugestii",
        adminSubtitle: "Gestioneaza conturile platformei",
        openMenu: "Deschide meniul"
      },
      home: {
        hero: {
          line1: "Reteaua europeana",
          line2: "a tinerilor",
          line3: "antreprenori verzi."
        },
        subtitle: "Conecteaza antreprenori, mentori, investitori si producatori intr-un singur loc.",
        welcome: "Bine ai venit",
        choosePath: "Alege unde vrei sa mergi.",
        loginTitle: "Autentificare",
        loginText: "Acceseaza-ti spatiul de lucru",
        registerTitle: "Inregistrare",
        registerText: "Creeaza un cont nou",
        partners: "Aceasta platforma a fost construita cu sprijinul partenerilor nostri.",
        contact: "Pentru intrebari, contacteaza:"
      },
      login: {
        title: "Bine ai revenit",
        subtitle: "Introdu datele tale pentru a accesa spatiul de lucru",
        emailLabel: "Adresa de email",
        emailPlaceholder: "nume@exemplu.com",
        passwordLabel: "Parola",
        signIn: "Autentificare",
        signingIn: "Se autentifica...",
        registerPrompt: "Nu ai cont?",
        registerNow: "Inregistreaza-te acum",
        googleFailed: "Autentificarea cu Google a esuat. Incearca din nou.",
        errors: {
          invalidCredentials: "Email sau parola invalida.",
          loginFailed: "Autentificarea a esuat. Incearca din nou.",
          unexpected: "A aparut o eroare neasteptata. Incearca din nou."
        },
        features: {
          entrepreneursTitle: "Antreprenori",
          entrepreneursText: "Conecteaza-te cu mentori, investitori si producatori potriviti etapei tale de crestere.",
          mentorsTitle: "Mentori",
          mentorsText: "Sprijina fondatorii cu expertiza tintita si ghidare structurata.",
          investorsTitle: "Investitori",
          investorsText: "Descopera startupuri selectate dupa sector, tractiune si nivel de pregatire.",
          manufacturersTitle: "Producatori",
          manufacturersText: "Colaboreaza cu startupuri pregatite pentru prototipare si productie."
        }
      },
      register: {
        platformTitle: "Reteaua europeana a tinerilor antreprenori verzi",
        platformSubtitle: "Platforma ecosistemului Younggreenteco",
        chooseRole: "Alege rolul tau",
        basicInfo: "Informatii de baza",
        firstName: "Prenume",
        lastName: "Nume",
        email: "Email",
        password: "Parola",
        createAccount: "Creeaza cont",
        alreadyHaveAccount: "Ai deja cont?",
        logIn: "Autentifica-te",
        continueWithGoogle: "Selecteaza un rol pentru a continua cu Google",
        alerts: {
          selectRoleFirst: "Te rog selecteaza un rol inainte sa continui cu Google",
          googleFailed: "Inregistrarea cu Google a esuat",
          authFailed: "Autentificarea cu Google a esuat"
        },
        errors: {
          selectRole: "Te rog selecteaza un rol",
          invalidEmail: "Adresa de email invalida",
          passwordUppercase: "Parola trebuie sa contina cel putin o litera mare",
          passwordBang: "Parola trebuie sa contina caracterul !",
          registrationFailed: "Inregistrarea a esuat. Incearca din nou."
        }
      },
      dashboard: {
        loading: "Se incarca panoul...",
        welcome: "Bine ai revenit, {{name}}",
        intro: "Privire rapida asupra activitatii tale si a functionalitatilor platformei.",
        overview: "Prezentare generala",
        upToDate: "Actualizat",
        quickGuide: "Ghid rapid",
        quickGuideSubtitle: "Cum functioneaza platforma",
        stats: {
          connections: "Conexiuni",
          connectionsHint: "Persoanele cu care esti conectat",
          projects: "Proiecte",
          projectsHint: "Proiectele create de tine",
          publications: "Publicatii",
          publicationsHint: "Lucrarile tale publicate"
        },
        steps: {
          profileTitle: "Completeaza-ti profilul",
          profileText: "Un profil detaliat imbunatateste potrivirile si vizibilitatea.",
          usersTitle: "Gaseste utilizatori compatibili",
          usersText: "Foloseste Matching sau Auto Matching pentru a descoperi persoane relevante.",
          connectionsTitle: "Construieste conexiuni",
          connectionsText: "Trimite cereri, accepta invitatii si colaboreaza.",
          projectsTitle: "Creeaza proiecte",
          projectsText: "Adauga proiecte pentru a-ti prezenta munca si a atrage colaboratori.",
          publicationsTitle: "Adauga publicatii",
          publicationsText: "Distribuie rezultate de cercetare si incarca documentele asociate."
        }
      },
      profile: {
        loading: "Se incarca profilul...",
        title: "Profilul meu",
        subtitle: "Actualizeaza detaliile si preferintele profilului. Modificarile se salveaza automat.",
        saveChanges: "Salveaza modificarile",
        savingButton: "Se salveaza...",
        saveAutomatic: "Se salveaza automat...",
        saveError: "Salvarea automata a esuat",
        savePending: "Exista modificari nesalvate...",
        saveComplete: "Toate modificarile au fost salvate",
        savedAt: "Salvat automat la {{time}}",
        saved: "Profil salvat.",
        saveFailed: "Salvarea profilului a esuat.",
        autosaveFailedLocal: "Salvarea automata a esuat. Modificarile sunt inca doar locale.",
        uploadingPhoto: "Se incarca fotografia...",
        photoUpdated: "Fotografia de profil a fost actualizata.",
        photoFailed: "Incarcarea fotografiei a esuat.",
        uploadingCv: "Se incarca CV-ul...",
        cvUploaded: "CV incarcat.",
        cvFailed: "Incarcarea CV-ului a esuat.",
        cvOpenFailed: "CV-ul nu a putut fi deschis.",
        header: "Prezentare profil",
        headerTip: "Avatarul tau si un indicator rapid al completarii profilului.",
        details: "Detalii profil",
        detailsTip: "Informatii de baza afisate public: headline, bio, locatie, afiliere, profesie si facultate.",
        collaboration: "Colaborare",
        collaborationTip: "Disponibilitate, nivel de experienta si preferinte de colaborare.",
        expertise: "Expertiza",
        expertiseTip: "Adauga arii de expertiza si o scurta descriere ca ceilalti sa inteleaga ce stii sa faci.",
        resources: "Laboratoare / Resurse",
        resourcesTip: "Optional, poti adauga linkuri catre laboratoare, instrumente, depozite, lucrari sau seturi de date.",
        companies: "Companii",
        companiesTip: "Adauga una sau mai multe companii si domeniile lor. Poti lasa gol.",
        links: "Linkuri externe",
        linksTip: "Adauga linkuri (LinkedIn, GitHub, website) ca ceilalti sa iti poata vedea activitatea.",
        profileStrength: "Puterea profilului",
        professionalHeadline: "Titlul tau profesional",
        uploadProfilePhotoAria: "Incarca fotografia de profil",
        openProfilePhotoAria: "Se incarca fotografia de profil",
        changePhoto: "Schimba fotografia",
        uploadPhoto: "Incarca fotografie",
        uploading: "Se incarca...",
        imageUploading: "Incarcarea imaginii este in curs...",
        imageRecommended: "Recomandat PNG, JPG sau WEBP.",
        replaceCv: "Inlocuieste CV-ul",
        uploadCv: "Incarca CV",
        viewCv: "Vezi CV-ul",
        noCv: "Nu exista CV incarcat",
        cvReady: "CV-ul este incarcat si gata de deschidere.",
        documentUploading: "Incarcarea documentului este in curs...",
        headline: "Headline",
        bio: "Bio",
        bioPlaceholder: "Adauga toate detaliile relevante despre experienta, expertiza, proiecte, publicatii si obiectivele tale de colaborare.",
        charactersLeft: "{{count}} caractere ramase",
        country: "Tara",
        city: "Oras",
        affiliation: "Afiliere",
        profession: "Profesie",
        university: "Universitate",
        availability: "Disponibilitate",
        experienceLevel: "Nivel de experienta",
        fullTime: "Full time",
        partTime: "Part time",
        weekends: "Weekenduri",
        junior: "Junior",
        mid: "Mid",
        senior: "Senior",
        openToProjects: "Deschis pentru proiecte",
        openToMentoring: "Deschis pentru mentorat",
        addExpertiseHint: "Adauga cel putin o arie ca ceilalti sa te poata gasi.",
        expertArea: "Arie de expertiza",
        expertAreaPlaceholder: "Cauta sau adauga o arie de expertiza",
        addExpertise: "+ Adauga expertiza",
        resourceHint: "Optional: adauga linkuri catre laboratoare, instrumente, lucrari sau depozite.",
        resourceUrl: "URL",
        addResource: "+ Adauga resursa",
        companyHint: "Optional: adauga o companie daca reprezinti o organizatie.",
        companyName: "Nume companie",
        companyDescription: "Descriere companie",
        domains: "Domenii",
        addCompany: "+ Adauga companie"
      },
      picker: {
        searchOrAdd: "Cauta sau adauga...",
        pressEnterToAdd: "Apasa Enter pentru a adauga daca nu este in lista."
      },
      accountSettings: {
        title: "Setari cont",
        cooldown: "Iti poti schimba din nou numele dupa: {{date}}",
        firstName: "Prenume",
        lastName: "Nume",
        cancel: "Anuleaza",
        save: "Salveaza",
        saving: "Se salveaza...",
        saved: "Salvat.",
        taken: "Acest nume este deja folosit. Te rog alege alta combinatie de prenume + nume.",
        cooldownError: "Iti poti schimba din nou numele dupa perioada de 14 zile.",
        invalid: "Nume invalid.",
        genericError: "Ceva nu a mers bine. Incearca din nou."
      },
      profileModal: {
        title: "Profil",
        profession: "Profesie",
        faculty: "Facultate",
        university: "Universitate",
        bio: "Bio",
        collaborations: "Colaborari",
        expertise: "Expertiza",
        resources: "Resurse",
        companies: "Companii",
        cv: "CV",
        openCv: "Deschide CV-ul",
        links: "Linkuri"
      },
      matching: {
        loadFailed: "Profilurile nu au putut fi incarcate.",
        profileLoadFailed: "Profilul nu a putut fi incarcat.",
        conversationFailed: "Conversatia nu a putut fi pornita.",
        title: "Matching",
        subtitle: "Rasfoieste profiluri si filtreaza dupa expertiza si disponibilitate.",
        sortBy: "Sorteaza dupa",
        sortName: "Nume",
        sortExpertise: "Arie de expertiza",
        sortAvailability: "Disponibilitate",
        sortProjects: "Deschis pentru proiecte",
        sortMentoring: "Deschis pentru mentorat",
        sortExperience: "Nivel de experienta",
        asc: "Asc",
        desc: "Desc",
        filterName: "Nume",
        searchByName: "Cauta dupa nume",
        filterExpertise: "Arie de expertiza",
        expertisePlaceholder: "Arie de expertiza",
        filterAvailability: "Disponibilitate",
        filterExperience: "Experienta",
        filterProjects: "Deschis pentru proiecte",
        filterMentoring: "Deschis pentru mentorat",
        empty: "Nu exista profiluri potrivite.",
        viewProfile: "Vezi profilul",
        requested: "Cerere trimisa",
        reviewRequest: "Vezi cererea",
        requestSent: "Cerere trimisa.",
        requestFailed: "Cererea nu a putut fi trimisa.",
        openProfile: "Deschide profilul",
        pageSummary: "Pagina {{page}} / {{total}} - {{count}} profiluri"
      },
      autoMatching: {
        loadFailed: "Potrivirile automate nu au putut fi incarcate.",
        profileLoadFailed: "Profilul nu a putut fi incarcat.",
        conversationFailed: "Conversatia nu a putut fi pornita.",
        requestSent: "Cererea de conexiune a fost trimisa.",
        requestFailed: "Cererea de conexiune nu a putut fi trimisa.",
        title: "Potrivire automata",
        subtitle: "Revizuieste cele mai bune potriviri automate si conecteaza-te mai repede.",
        empty: "Nu exista rezultate.",
        whyMatch: "De ce va potriviti",
        noDetails: "Nu exista detalii despre potrivire.",
        affiliation: "Afiliere",
        experience: "Experienta",
        expertise: "Expertiza",
        collaboration: "Colaborare",
        bio: "Bio",
        totalScore: "Scor total",
        unknown: "Necunoscut",
        profileButton: "Profil",
        slideAria: "Mergi la slide-ul {{index}}",
        previous: "Anterior",
        next: "Urmator"
      },
      connectionRequests: {
        loadFailed: "Cererea nu a putut fi incarcata.",
        acceptFailed: "Cererea nu a putut fi acceptata.",
        rejectFailed: "Cererea nu a putut fi respinsa.",
        title: "Cereri de conexiune",
        subtitle: "Aici poti accepta sau respinge cereri de conexiune. Pentru a trimite una noua, mergi la Matching sau deschide un profil.",
        empty: "Nu exista cereri in asteptare. Daca vrei sa te conectezi cu cineva, mergi la Matching si trimite o cerere.",
        accept: "Accepta",
        reject: "Respinge",
        user: "Utilizator"
      },
      connections: {
        title: "Conexiuni",
        subtitle: "Persoanele cu care esti deja conectat. De aici poti deschide profiluri sau porni o conversatie.",
        empty: "Nu exista conexiuni inca. Mergi la Matching ca sa descoperi oameni si sa trimiti cereri de conexiune.",
        loadFailed: "Conexiunile nu au putut fi incarcate.",
        profileLoadFailed: "Profilul nu a putut fi incarcat.",
        conversationFailed: "Conversatia nu a putut fi pornita."
      },
      announcements: {
        title: "Anunturi",
        subtitle: "Actualizari de la oameni si proiecte, cele mai noi primele.",
        refreshing: "Se reimprospateaza...",
        composerPlaceholder: "Scrie o actualizare...",
        previewAlt: "Previzualizare imagine",
        removeImage: "Sterge imaginea",
        attachPhoto: "Ataseaza o fotografie",
        photo: "Foto",
        postUpdate: "Publica actualizarea",
        uploading: "Se incarca...",
        posting: "Se publica...",
        post: "Publica",
        loadMore: "Incarca mai mult",
        loadFailed: "Anunturile nu au putut fi incarcate.",
        profileLoadFailed: "Profilul nu a putut fi incarcat.",
        imageFileOnly: "Te rog alege un fisier imagine.",
        imageTooLarge: "Imaginea este prea mare (maxim 8 MB).",
        posted: "Publicat.",
        postFailed: "Publicarea a esuat.",
        commentAdded: "Comentariu adaugat.",
        commentFailed: "Comentariul nu a putut fi adaugat.",
        commentDeleted: "Comentariu sters.",
        commentDeleteFailed: "Comentariul nu a putut fi sters.",
        deleteFallback: "aceasta postare",
        deleted: "Postare stearsa.",
        deleteFailed: "Postarea nu a putut fi stearsa.",
        conversationFailed: "Conversatia nu a putut fi pornita.",
        deleteTitle: "Sterge postarea",
        deleteMessage: "Stergi \"{{title}}\"? Actiunea nu poate fi anulata.",
        deleting: "Se sterge...",
        deletePost: "Sterge postarea",
        deleteComment: "Sterge comentariul",
        postImageAlt: "Imagine postare",
        likesCount: "{{count}} aprecieri",
        commentsCount: "{{count}} comentarii",
        like: "Apreciaza",
        comment: "Comenteaza",
        commentPlaceholder: "Scrie un comentariu..."
      },
      adminUsers: {
        usersLoadFailed: "Utilizatorii nu au putut fi incarcati.",
        userUpdated: "Detaliile utilizatorului au fost actualizate.",
        userUpdateFailed: "Detaliile utilizatorului nu au putut fi actualizate.",
        userDeleted: "Contul utilizatorului a fost sters.",
        userDeleteFailed: "Utilizatorul nu a putut fi sters.",
        eyebrow: "Instrumente administrator",
        title: "Administrare utilizatori",
        subtitle: "Accesul este limitat conturilor cu rol backend ADMIN. Supervisorii pot gestiona conturile de administrator. Administratorii pot gestiona doar utilizatorii standard.",
        totalUsers: "Total utilizatori",
        adminAccounts: "Conturi admin",
        projects: "Proiecte",
        publications: "Publicatii",
        announcements: "Anunturi",
        pendingRequests: "Cereri in asteptare",
        roleBreakdown: "Distributie pe roluri",
        activeRoles: "{{count}} roluri active",
        usersCount: "{{count}} utilizatori",
        searchUsers: "Cauta utilizatori",
        searchPlaceholder: "Nume sau email",
        currentAccount: "Cont curent: {{name}}",
        loadingUsers: "Se incarca utilizatorii...",
        noUsers: "Niciun utilizator nu corespunde cautarii.",
        currentAccountBadge: "Cont curent",
        userId: "ID utilizator #{{id}}",
        selfLocked: "Propriul tau cont de admin este blocat in acest panou pentru ca sesiunea curenta sa ramana valida.",
        supervisorProtected: "Conturile de supervisor sunt protejate si trebuie gestionate manual din afara acestui panou.",
        adminRestricted: "Administratorii nu pot gestiona conturi de administrator sau supervisor.",
        firstName: "Prenume",
        lastName: "Nume",
        email: "Email",
        role: "Rol",
        saveChanges: "Salveaza modificarile",
        deleteTitle: "Stergi contul utilizatorului?",
        deleteMessage: "Esti pe punctul de a sterge utilizatorul {{name}}. Vor fi sterse si profilul, proiectele, publicatiile, mesajele si anunturile asociate.",
        deleting: "Se sterge...",
        deletePermanently: "Sterge definitiv",
        roles: {
          citizen: "Cetatean",
          entrepreneurs: "Antreprenori",
          mentors: "Mentori",
          investors: "Investitori",
          manufacturers: "Producatori",
          admin: "Administrator",
          supervisor: "Supervisor"
        }
      },
      messagesPage: {
        conversationsLoadFailed: "Conversatiile nu au putut fi incarcate.",
        messagesLoadFailed: "Mesajele nu au putut fi incarcate.",
        pdfOnly: "Sunt permise doar fisiere PDF.",
        pdfTooLarge: "PDF-ul este prea mare (maxim 25MB).",
        sendFailed: "Mesajul nu a putut fi trimis.",
        downloadFailed: "Atasamentul nu a putut fi descarcat.",
        removedToast: "Conversatia cu {{name}} a fost scoasa din lista ta.",
        removeFailed: "Conversatia nu a putut fi eliminata.",
        title: "Mesaje",
        subtitle: "Conversatiile tale. Daca nu ai mesaje, incepe prin a te conecta cu cineva.",
        searchPlaceholder: "Cauta...",
        noResults: "Nu exista rezultate.",
        noConversations: "Nu exista conversatii inca. Mergi la Connections si incepe un mesaj.",
        selectConversation: "Selecteaza o conversatie",
        chooseConversation: "Alege o conversatie ca sa incepi sa scrii.",
        selectFromLeft: "Selecteaza o conversatie din stanga sau mergi la Connections ca sa incepi una.",
        loadingMessages: "Se incarca mesajele...",
        you: "Tu",
        openPdf: "Deschide PDF",
        attachPdf: "Ataseaza PDF",
        pdfOptional: "PDF optional",
        writeMessage: "Scrie un mesaj...",
        selectConversationFirst: "Selecteaza mai intai o conversatie",
        removeTitle: "Elimina conversatia",
        removeMessage: "Elimini conversatia cu \"{{name}}\" din lista ta?"
      },
      projects: {
        title: "Proiecte",
        subtitle: "Creeaza proiectele tale si exploreaza proiectele publicate de altii.",
        myProjects: "Proiectele mele",
        exploreProjects: "Exploreaza proiecte",
        explore: "Exploreaza",
        newProject: "+ Proiect nou",
        addProject: "Adauga proiect",
        acronym: "Acronim",
        searchPlaceholder: "Cauta...",
        noProjectsYet: "Nu exista proiecte inca.",
        noProjects: "Nu exista proiecte.",
        abstract: "Rezumat",
        timeline: "Perioada:",
        extension: "Ext:",
        startDate: "Data inceput",
        endDate: "Data final",
        extensionEnd: "Posibila prelungire pana la",
        contractNumber: "Numar contract",
        coordinator: "Coordonator",
        partners: "Parteneri",
        partner: "Partener",
        addPartner: "Adauga partener",
        removePartner: "Sterge partener",
        deleteTitle: "Sterge proiect",
        deleteMessage: "Stergi \"{{title}}\"? Actiunea nu poate fi anulata.",
        deleting: "Se sterge...",
        loadProfileFailed: "Profilul nu a putut fi incarcat.",
        viewProfile: "Vezi profilul"
      },
      publications: {
        title: "Publicatii",
        subtitle: "Adauga publicatiile tale si exploreaza publicatiile publicate de altii.",
        myPublications: "Publicatiile mele",
        explore: "Exploreaza",
        newPublication: "+ Publicatie noua",
        searchPublications: "Cauta publicatii",
        searchPlaceholder: "Cauta dupa titlu, autori, jurnal, DOI, utilizator...",
        noPublicationsYet: "Nu exista publicatii inca.",
        noResults: "Nu exista rezultate.",
        type: "Tip",
        publicationTitle: "Titlu",
        publicationTitlePlaceholder: "Titlul publicatiei",
        authors: "Autori",
        externalLink: "Link extern",
        publicationDate: "Data publicarii",
        year: "An",
        keywords: "Cuvinte cheie",
        journalConferenceTitle: "Titlu jurnal / conferinta",
        journalConference: "Jurnal / conferinta",
        volumeIssue: "Volum / numar",
        pages: "Pagini",
        doi: "DOI",
        publisher: "Editura",
        pdfUpload: "PDF (max 10 MB)",
        replacePdf: "Inlocuieste PDF-ul (max 10 MB)",
        openCurrentPdf: "Deschide PDF-ul curent",
        saved: "Publicatie salvata.",
        saveFailed: "Publicatia nu a putut fi salvata.",
        updated: "Publicatie actualizata.",
        updateFailed: "Publicatia nu a putut fi actualizata.",
        deleted: "Publicatie stearsa.",
        deleteFailed: "Publicatia nu a putut fi stearsa.",
        openPdfFailed: "PDF-ul nu a putut fi deschis.",
        loadFailed: "Publicatiile nu au putut fi incarcate.",
        profileLoadFailed: "Profilul nu a putut fi incarcat.",
        conversationFailed: "Conversatia nu a putut fi pornita.",
        deleteTitle: "Sterge publicatia",
        deleteAdminTitle: "Sterge publicatia (admin)",
        deleteMessage: "Stergi \"{{title}}\"? Actiunea nu poate fi anulata.",
        deleting: "Se sterge...",
        titleRequired: "Titlul este obligatoriu.",
        yearInvalid: "Anul trebuie sa fie intre 1900 si 2100.",
        dateRequired: "Data publicarii este obligatorie.",
        publisherRequired: "Editura este obligatorie pentru carti/capitole.",
        journalRequired: "Titlul jurnalului / conferintei este obligatoriu.",
        pdfTooLarge: "PDF-ul trebuie sa aiba maximum 10 MB.",
        pdfOnly: "Sunt permise doar fisiere PDF.",
        typeJournalArticle: "Articol de jurnal",
        typeConferencePaper: "Lucrare de conferinta",
        typeBook: "Carte",
        typeBookChapter: "Capitol de carte"
      }
    }
  },
  tr: {
    translation: {
      common: {
        loading: "Yukleniyor...",
        menu: "Menu",
        dashboard: "Panel",
        myProfile: "Profilim",
        adminPanel: "Yonetici Paneli",
        projects: "Projeler",
        publications: "Yayinlar",
        announcements: "Duyurular",
        messages: "Mesajlar",
        matching: "Eslestirme",
        autoMatching: "Otomatik Eslestirme",
        connections: "Baglantilar",
        requests: "Istekler",
        logout: "Cikis yap",
        language: "Dil",
        view: "Goruntule",
        manage: "Yonet",
        editProfile: "Profili duzenle",
        close: "Kapat",
        message: "Mesaj",
        refresh: "Yenile",
        search: "Ara",
        reset: "Sifirla",
        previous: "Onceki",
        next: "Sonraki",
        any: "Farketmez",
        yes: "Evet",
        no: "Hayir",
        connect: "Baglan",
        connected: "Bagli",
        pending: "Beklemede",
        send: "Gonder",
        sending: "Gonderiliyor...",
        upload: "Yukle",
        replace: "Degistir",
        open: "Ac",
        remove: "Kaldir",
        add: "Ekle",
        edit: "Duzenle",
        delete: "Sil",
        cancel: "Iptal",
        save: "Kaydet",
        create: "Olustur",
        details: "Detaylar",
        profile: "Profil",
        pdf: "PDF",
        link: "Baglanti",
        searching: "Araniyor...",
        unknownUser: "Bilinmeyen kullanici",
        description: "Aciklama",
        title: "Baslik",
        website: "Web sitesi",
        linkedin: "LinkedIn",
        github: "GitHub",
        or: "VEYA",
        orContinueWith: "VEYA SUNUNLA DEVAM ET"
      },
      theme: {
        day: "Gunduz",
        night: "Gece",
        switchToLight: "Acik moda gec",
        switchToDark: "Koyu moda gec"
      },
      brand: {
        name: "Youngreenteco",
        tagline: "Baglan ve buyu"
      },
      sections: {
        admin: "Yonetim",
        explore: "Kesfet"
      },
      roles: {
        ADMIN: "Yonetici",
        SUPERVISOR: "Supervisor",
        ENTREPRENEURS: "Girisimciler",
        MENTORS: "Mentorlar",
        INVESTORS: "Yatirimcilar",
        MANUFACTURERS: "Ureticiler"
      },
      layout: {
        defaultTitle: "Sayfa",
        dashboardSubtitle: "Genel bakis ve oneriler",
        adminSubtitle: "Platform hesaplarini yonet",
        openMenu: "Menuyu ac"
      },
      home: {
        hero: {
          line1: "Genc yesil",
          line2: "girisimcilerin",
          line3: "Avrupa agi."
        },
        subtitle: "Girisimcileri, mentorlari, yatirimcilari ve ureticileri tek bir yerde bulusturun.",
        welcome: "Hos geldiniz",
        choosePath: "Nereye gitmek istediginizi secin.",
        loginTitle: "Giris yap",
        loginText: "Calisma alaniniza erisin",
        registerTitle: "Kayit ol",
        registerText: "Yeni bir hesap olusturun",
        partners: "Bu platform ortaklarimizin destegiyle olusturuldu.",
        contact: "Sorular icin iletisim:"
      },
      login: {
        title: "Tekrar hos geldiniz",
        subtitle: "Calisma alaniniza erismek icin bilgilerinizi girin",
        emailLabel: "E-posta adresi",
        emailPlaceholder: "ad@example.com",
        passwordLabel: "Sifre",
        signIn: "Giris yap",
        signingIn: "Giris yapiliyor...",
        registerPrompt: "Hesabiniz yok mu?",
        registerNow: "Simdi kayit ol",
        googleFailed: "Google ile kimlik dogrulama basarisiz oldu. Lutfen tekrar deneyin.",
        errors: {
          invalidCredentials: "E-posta veya sifre gecersiz.",
          loginFailed: "Giris basarisiz oldu. Lutfen tekrar deneyin.",
          unexpected: "Beklenmeyen bir hata olustu. Lutfen tekrar deneyin."
        },
        features: {
          entrepreneursTitle: "Girisimciler",
          entrepreneursText: "Buyume asamaniza uygun mentorlar, yatirimcilar ve ureticilerle baglanin.",
          mentorsTitle: "Mentorlar",
          mentorsText: "Kuruculara hedefli uzmanlik ve yapilandirilmis rehberlik saglayin.",
          investorsTitle: "Yatirimcilar",
          investorsText: "Sektor, cekis gucu ve hazirlik seviyesine gore secilmis startup'lari kesfedin.",
          manufacturersTitle: "Ureticiler",
          manufacturersText: "Prototipleme ve uretime hazir startup'larla is birligi yapin."
        }
      },
      register: {
        platformTitle: "Genc yesil girisimcilerin Avrupa agi",
        platformSubtitle: "Younggreenteco ekosistem platformu",
        chooseRole: "Rolunuzu secin",
        basicInfo: "Temel bilgiler",
        firstName: "Ad",
        lastName: "Soyad",
        email: "E-posta",
        password: "Sifre",
        createAccount: "Hesap olustur",
        alreadyHaveAccount: "Zaten bir hesabin var mi?",
        logIn: "Giris yap",
        continueWithGoogle: "Google ile devam etmek icin bir rol secin",
        alerts: {
          selectRoleFirst: "Google ile devam etmeden once lutfen bir rol secin",
          googleFailed: "Google ile kayit basarisiz oldu",
          authFailed: "Google kimlik dogrulamasi basarisiz oldu"
        },
        errors: {
          selectRole: "Lutfen bir rol secin",
          invalidEmail: "Gecersiz e-posta adresi",
          passwordUppercase: "Sifre en az bir buyuk harf icermelidir",
          passwordBang: "Sifre ! karakterini icermelidir",
          registrationFailed: "Kayit basarisiz oldu. Lutfen tekrar deneyin."
        }
      },
      dashboard: {
        loading: "Panel yukleniyor...",
        welcome: "Tekrar hos geldin, {{name}}",
        intro: "Etkinliginizin ve platform ozelliklerinin hizli bir ozeti.",
        overview: "Genel bakis",
        upToDate: "Guncel",
        quickGuide: "Hizli kilavuz",
        quickGuideSubtitle: "Platform nasil calisir",
        stats: {
          connections: "Baglantilar",
          connectionsHint: "Bagli oldugunuz kisiler",
          projects: "Projeler",
          projectsHint: "Olusturdugunuz projeler",
          publications: "Yayinlar",
          publicationsHint: "Yayimlanan calismalariniz"
        },
        steps: {
          profileTitle: "Profilinizi tamamlayin",
          profileText: "Detayli bir profil eslestirmeyi ve gorunurlugu artirir.",
          usersTitle: "Uyumlu kullanicilari bulun",
          usersText: "Ilgili kisileri kesfetmek icin Matching veya Auto Matching kullanin.",
          connectionsTitle: "Baglantilar kurun",
          connectionsText: "Istek gonderin, davetleri kabul edin ve is birligi yapin.",
          projectsTitle: "Projeler olusturun",
          projectsText: "Calismanizi gostermek ve is birlikciler cekmek icin projeler ekleyin.",
          publicationsTitle: "Yayinlar ekleyin",
          publicationsText: "Arastirma ciktilarinizi paylasin ve ilgili belgeleri yukleyin."
        }
      },
      profile: {
        loading: "Profil yukleniyor...",
        title: "Profilim",
        subtitle: "Profil bilgilerini ve tercihlerini guncelle. Degisiklikler otomatik kaydedilir.",
        saveChanges: "Degisiklikleri kaydet",
        savingButton: "Kaydediliyor...",
        saveAutomatic: "Otomatik kaydediliyor...",
        saveError: "Otomatik kayit basarisiz oldu",
        savePending: "Kaydedilmemis degisiklikler var...",
        saveComplete: "Tum degisiklikler kaydedildi",
        savedAt: "{{time}} saatinde otomatik kaydedildi",
        saved: "Profil kaydedildi.",
        saveFailed: "Profil kaydedilemedi.",
        autosaveFailedLocal: "Otomatik kayit basarisiz oldu. Degisiklikler yalnizca yerel olarak duruyor.",
        uploadingPhoto: "Fotograf yukleniyor...",
        photoUpdated: "Profil fotografi guncellendi.",
        photoFailed: "Fotograf yukleme basarisiz oldu.",
        uploadingCv: "CV yukleniyor...",
        cvUploaded: "CV yuklendi.",
        cvFailed: "CV yukleme basarisiz oldu.",
        cvOpenFailed: "CV acilamadi.",
        header: "Profil ozeti",
        headerTip: "Avatarin ve hizli bir profil gucu gostergesi.",
        details: "Profil detaylari",
        detailsTip: "Herkese acik gorunen temel bilgiler: headline, bio, konum, baglilik, meslek ve fakulte.",
        collaboration: "Is birligi",
        collaborationTip: "Musaitlik, deneyim seviyesi ve is birligi tercihleri.",
        expertise: "Uzmanlik",
        expertiseTip: "Beceri alanlarini ve kisa bir aciklamayi ekle ki insanlar seni daha iyi tanisin.",
        resources: "Laboratuvarlar / Kaynaklar",
        resourcesTip: "Istege bagli olarak laboratuvarlara, araclara, depolara, makalelere veya veri setlerine baglantilar ekle.",
        companies: "Sirketler",
        companiesTip: "Bir veya daha fazla sirket ve alanlarini ekle. Bos birakabilirsin.",
        links: "Harici baglantilar",
        linksTip: "Baskalari calismani gorebilsin diye LinkedIn, GitHub veya web sitesi baglantilari ekle.",
        profileStrength: "Profil gucu",
        professionalHeadline: "Profesyonel basligin",
        uploadProfilePhotoAria: "Profil fotografi yukle",
        openProfilePhotoAria: "Profil fotografi yukleniyor",
        changePhoto: "Fotografi degistir",
        uploadPhoto: "Fotograf yukle",
        uploading: "Yukleniyor...",
        imageUploading: "Gorsel yukleme suruyor...",
        imageRecommended: "PNG, JPG veya WEBP onerilir.",
        replaceCv: "CV degistir",
        uploadCv: "CV yukle",
        viewCv: "CV goruntule",
        noCv: "Yuklenmis CV yok",
        cvReady: "CV yuklendi ve goruntulemeye hazir.",
        documentUploading: "Belge yukleme suruyor...",
        headline: "Headline",
        bio: "Bio",
        bioPlaceholder: "Gecmisin, uzmanligin, projelerin, yayinlarin ve is birligi hedeflerin hakkinda tum ilgili bilgileri ekle.",
        charactersLeft: "{{count}} karakter kaldi",
        country: "Ulke",
        city: "Sehir",
        affiliation: "Baglilik",
        profession: "Meslek",
        university: "Universite",
        availability: "Musaitlik",
        experienceLevel: "Deneyim seviyesi",
        fullTime: "Tam zamanli",
        partTime: "Yari zamanli",
        weekends: "Hafta sonlari",
        junior: "Junior",
        mid: "Mid",
        senior: "Senior",
        openToProjects: "Projelere acik",
        openToMentoring: "Mentorluga acik",
        addExpertiseHint: "Baskalarinin seni bulabilmesi icin en az bir alan ekle.",
        expertArea: "Uzmanlik alani",
        expertAreaPlaceholder: "Bir uzmanlik alani ara veya ekle",
        addExpertise: "+ Uzmanlik ekle",
        resourceHint: "Istege bagli: laboratuvarlara, araclara, makalelere veya depolara baglantilar ekle.",
        resourceUrl: "URL",
        addResource: "+ Kaynak ekle",
        companyHint: "Istege bagli: bir kurumu temsil ediyorsan bir sirket ekle.",
        companyName: "Sirket adi",
        companyDescription: "Sirket aciklamasi",
        domains: "Alanlar",
        addCompany: "+ Sirket ekle"
      },
      picker: {
        searchOrAdd: "Ara veya ekle...",
        pressEnterToAdd: "Listede yoksa eklemek icin Enter'a basin."
      },
      accountSettings: {
        title: "Hesap ayarlari",
        cooldown: "Adini tekrar su tarihten sonra degistirebilirsin: {{date}}",
        firstName: "Ad",
        lastName: "Soyad",
        cancel: "Iptal",
        save: "Kaydet",
        saving: "Kaydediliyor...",
        saved: "Kaydedildi.",
        taken: "Bu ad zaten kullaniliyor. Lutfen farkli bir ad + soyad kullan.",
        cooldownError: "Adini 14 gunluk bekleme suresinden sonra tekrar degistirebilirsin.",
        invalid: "Gecersiz ad.",
        genericError: "Bir seyler ters gitti. Lutfen tekrar dene."
      },
      profileModal: {
        title: "Profil",
        profession: "Meslek",
        faculty: "Fakulte",
        university: "Universite",
        bio: "Bio",
        collaborations: "Is birlikleri",
        expertise: "Uzmanlik",
        resources: "Kaynaklar",
        companies: "Sirketler",
        cv: "CV",
        openCv: "CV'yi ac",
        links: "Baglantilar"
      },
      matching: {
        loadFailed: "Profiller yuklenemedi.",
        profileLoadFailed: "Profil yuklenemedi.",
        conversationFailed: "Konusma baslatilamadi.",
        title: "Matching",
        subtitle: "Profillere goz at ve uzmanlik ile musaitlige gore filtrele.",
        sortBy: "Sirala",
        sortName: "Ad",
        sortExpertise: "Uzmanlik alani",
        sortAvailability: "Musaitlik",
        sortProjects: "Projelere acik",
        sortMentoring: "Mentorluga acik",
        sortExperience: "Deneyim seviyesi",
        asc: "Artan",
        desc: "Azalan",
        filterName: "Ad",
        searchByName: "Ada gore ara",
        filterExpertise: "Uzmanlik alani",
        expertisePlaceholder: "Uzmanlik alani",
        filterAvailability: "Musaitlik",
        filterExperience: "Deneyim",
        filterProjects: "Projelere acik",
        filterMentoring: "Mentorluga acik",
        empty: "Eslesen profil yok.",
        viewProfile: "Profili gor",
        requested: "Istek gonderildi",
        reviewRequest: "Istegi incele",
        requestSent: "Istek gonderildi.",
        requestFailed: "Istek gonderilemedi.",
        openProfile: "Profili ac",
        pageSummary: "Sayfa {{page}} / {{total}} - {{count}} profil"
      },
      autoMatching: {
        loadFailed: "Otomatik eslesmeler yuklenemedi.",
        profileLoadFailed: "Profil yuklenemedi.",
        conversationFailed: "Konusma baslatilamadi.",
        requestSent: "Baglanti istegi gonderildi.",
        requestFailed: "Baglanti istegi gonderilemedi.",
        title: "Otomatik eslestirme",
        subtitle: "En guclu otomatik eslesmelerini incele ve daha hizli baglan.",
        empty: "Sonuc yok.",
        whyMatch: "Neden eslesiyorsunuz",
        noDetails: "Eslesme ayrintisi yok.",
        affiliation: "Baglilik",
        experience: "Deneyim",
        expertise: "Uzmanlik",
        collaboration: "Is birligi",
        bio: "Bio",
        totalScore: "Toplam puan",
        unknown: "Bilinmiyor",
        profileButton: "Profil",
        slideAria: "{{index}} numarali slayta git",
        previous: "Onceki",
        next: "Sonraki"
      },
      connectionRequests: {
        loadFailed: "Istekler yuklenemedi.",
        acceptFailed: "Istek kabul edilemedi.",
        rejectFailed: "Istek reddedilemedi.",
        title: "Baglanti istekleri",
        subtitle: "Buradan baglanti isteklerini kabul edebilir veya reddedebilirsin. Yeni istek gondermek icin Matching'e git veya bir profil ac.",
        empty: "Bekleyen istek yok. Biriyle baglanmak istiyorsan Matching'e git ve bir istek gonder.",
        accept: "Kabul et",
        reject: "Reddet",
        user: "Kullanici"
      },
      connections: {
        title: "Baglantilar",
        subtitle: "Bagli oldugun kisiler. Buradan profilleri acabilir veya bir konusma baslatabilirsin.",
        empty: "Henuz baglanti yok. Kisileri kesfetmek ve baglanti istegi gondermek icin Matching'e git.",
        loadFailed: "Baglantilar yuklenemedi.",
        profileLoadFailed: "Profil yuklenemedi.",
        conversationFailed: "Konusma baslatilamadi."
      },
      announcements: {
        title: "Duyurular",
        subtitle: "Kisilerden ve projelerden guncellemeler, en yeniler once.",
        refreshing: "Yenileniyor...",
        composerPlaceholder: "Bir guncelleme paylas...",
        previewAlt: "Gorsel onizleme",
        removeImage: "Gorseli kaldir",
        attachPhoto: "Bir foto ekle",
        photo: "Foto",
        postUpdate: "Guncelleme paylas",
        uploading: "Yukleniyor...",
        posting: "Paylasiliyor...",
        post: "Paylas",
        loadMore: "Daha fazla yukle",
        loadFailed: "Duyurular yuklenemedi.",
        profileLoadFailed: "Profil yuklenemedi.",
        imageFileOnly: "Lutfen bir gorsel dosyasi sec.",
        imageTooLarge: "Gorsel cok buyuk (en fazla 8 MB).",
        posted: "Paylasildi.",
        postFailed: "Paylasim basarisiz.",
        commentAdded: "Yorum eklendi.",
        commentFailed: "Yorum eklenemedi.",
        commentDeleted: "Yorum silindi.",
        commentDeleteFailed: "Yorum silinemedi.",
        deleteFallback: "bu gonderi",
        deleted: "Gonderi silindi.",
        deleteFailed: "Gonderi silinemedi.",
        conversationFailed: "Konusma baslatilamadi.",
        deleteTitle: "Gonderiyi sil",
        deleteMessage: "\"{{title}}\" silinsin mi? Bu islem geri alinamaz.",
        deleting: "Siliniyor...",
        deletePost: "Gonderiyi sil",
        deleteComment: "Yorumu sil",
        postImageAlt: "Gonderi gorseli",
        likesCount: "{{count}} begeni",
        commentsCount: "{{count}} yorum",
        like: "Begen",
        comment: "Yorum",
        commentPlaceholder: "Bir yorum yaz..."
      },
      adminUsers: {
        usersLoadFailed: "Kullanicilar yuklenemedi.",
        userUpdated: "Kullanici bilgileri guncellendi.",
        userUpdateFailed: "Kullanici bilgileri guncellenemedi.",
        userDeleted: "Kullanici hesabi silindi.",
        userDeleteFailed: "Kullanici silinemedi.",
        eyebrow: "Yonetici araclari",
        title: "Kullanici yonetimi",
        subtitle: "Erisim yalnizca backend rolu ADMIN olan hesaplarla sinirlidir. Supervisor hesaplari yonetici hesaplarini yonetebilir. Yoneticiler yalnizca standart kullanicilari yonetebilir.",
        totalUsers: "Toplam kullanici",
        adminAccounts: "Yonetici hesaplari",
        projects: "Projeler",
        publications: "Yayinlar",
        announcements: "Duyurular",
        pendingRequests: "Bekleyen istekler",
        roleBreakdown: "Rol dagilimi",
        activeRoles: "{{count}} aktif rol",
        usersCount: "{{count}} kullanici",
        searchUsers: "Kullanici ara",
        searchPlaceholder: "Ad veya e-posta",
        currentAccount: "Guncel hesap: {{name}}",
        loadingUsers: "Kullanicilar yukleniyor...",
        noUsers: "Aramana uyan kullanici bulunamadi.",
        currentAccountBadge: "Guncel hesap",
        userId: "Kullanici ID #{{id}}",
        selfLocked: "Gecerli oturumun aktif kalmasi icin kendi yonetici hesabin bu panelde kilitlidir.",
        supervisorProtected: "Supervisor hesaplari korunur ve bu panel disinda elle yonetilmelidir.",
        adminRestricted: "Yoneticiler baska yonetici veya supervisor hesaplarini yonetemez.",
        firstName: "Ad",
        lastName: "Soyad",
        email: "E-posta",
        role: "Rol",
        saveChanges: "Degisiklikleri kaydet",
        deleteTitle: "Kullanici hesabi silinsin mi?",
        deleteMessage: "{{name}} kullanicisini silmek uzeresin. Buna ilgili profil verileri, projeler, yayinlar, mesajlar ve duyurular da dahildir.",
        deleting: "Siliniyor...",
        deletePermanently: "Kalici olarak sil",
        roles: {
          citizen: "Vatandas",
          entrepreneurs: "Girisimciler",
          mentors: "Mentorler",
          investors: "Yatirimcilar",
          manufacturers: "Ureticiler",
          admin: "Yonetici",
          supervisor: "Supervisor"
        }
      },
      messagesPage: {
        conversationsLoadFailed: "Konusmalar yuklenemedi.",
        messagesLoadFailed: "Mesajlar yuklenemedi.",
        pdfOnly: "Yalnizca PDF dosyalarina izin verilir.",
        pdfTooLarge: "PDF cok buyuk (maksimum 25MB).",
        sendFailed: "Mesaj gonderilemedi.",
        downloadFailed: "Ek indirilemedi.",
        removedToast: "{{name}} ile olan konusma listenden kaldirildi.",
        removeFailed: "Konusma kaldirilamadi.",
        title: "Mesajlar",
        subtitle: "Konusmalarin. Mesajin yoksa birisiyle baglanti kurarak basla.",
        searchPlaceholder: "Ara...",
        noResults: "Sonuc yok.",
        noConversations: "Henuz konusma yok. Connections sayfasina git ve bir mesaj baslat.",
        selectConversation: "Bir konusma sec",
        chooseConversation: "Sohbete baslamak icin bir konusma sec.",
        selectFromLeft: "Soldan bir konusma sec veya bir tane baslatmak icin Connections sayfasina git.",
        loadingMessages: "Mesajlar yukleniyor...",
        you: "Sen",
        openPdf: "PDF ac",
        attachPdf: "PDF ekle",
        pdfOptional: "PDF istege bagli",
        writeMessage: "Bir mesaj yaz...",
        selectConversationFirst: "Once bir konusma sec",
        removeTitle: "Konusmayi kaldir",
        removeMessage: "\"{{name}}\" ile olan konusma listenden kaldirilsin mi?"
      },
      projects: {
        title: "Projeler",
        subtitle: "Projelerini olustur ve baskalari tarafindan yayinlanan projeleri kesfet.",
        myProjects: "Projelerim",
        exploreProjects: "Projeleri kesfet",
        explore: "Kesfet",
        newProject: "+ Yeni proje",
        addProject: "Proje ekle",
        acronym: "Kisaltma",
        searchPlaceholder: "Ara...",
        noProjectsYet: "Henuz proje yok.",
        noProjects: "Proje yok.",
        abstract: "Ozet",
        timeline: "Zaman cizelgesi:",
        extension: "Uzatma:",
        startDate: "Baslangic tarihi",
        endDate: "Bitis tarihi",
        extensionEnd: "Olasi uzatma bitisi",
        contractNumber: "Sozlesme numarasi",
        coordinator: "Koordinator",
        partners: "Ortaklar",
        partner: "Ortak",
        addPartner: "Ortak ekle",
        removePartner: "Ortagi kaldir",
        deleteTitle: "Projeyi sil",
        deleteMessage: "\"{{title}}\" silinsin mi? Bu islem geri alinamaz.",
        deleting: "Siliniyor...",
        loadProfileFailed: "Profil yuklenemedi.",
        viewProfile: "Profili gor"
      },
      publications: {
        title: "Yayinlar",
        subtitle: "Yayinlarini ekle ve baskalari tarafindan yayinlanan calismalari kesfet.",
        myPublications: "Yayinlarim",
        explore: "Kesfet",
        newPublication: "+ Yeni yayin",
        searchPublications: "Yayin ara",
        searchPlaceholder: "Baslik, yazar, dergi, DOI veya kullaniciya gore ara...",
        noPublicationsYet: "Henuz yayin yok.",
        noResults: "Sonuc yok.",
        type: "Tur",
        publicationTitle: "Baslik",
        publicationTitlePlaceholder: "Yayin basligi",
        authors: "Yazarlar",
        externalLink: "Harici baglanti",
        publicationDate: "Yayin tarihi",
        year: "Yil",
        keywords: "Anahtar kelimeler",
        journalConferenceTitle: "Dergi / konferans basligi",
        journalConference: "Dergi / konferans",
        volumeIssue: "Cilt / sayi",
        pages: "Sayfalar",
        doi: "DOI",
        publisher: "Yayinci",
        pdfUpload: "PDF (maksimum 10 MB)",
        replacePdf: "PDF'yi degistir (maksimum 10 MB)",
        openCurrentPdf: "Mevcut PDF'yi ac",
        saved: "Yayin kaydedildi.",
        saveFailed: "Yayin kaydedilemedi.",
        updated: "Yayin guncellendi.",
        updateFailed: "Yayin guncellenemedi.",
        deleted: "Yayin silindi.",
        deleteFailed: "Yayin silinemedi.",
        openPdfFailed: "PDF acilamadi.",
        loadFailed: "Yayinlar yuklenemedi.",
        profileLoadFailed: "Profil yuklenemedi.",
        conversationFailed: "Konusma baslatilamadi.",
        deleteTitle: "Yayini sil",
        deleteAdminTitle: "Yayini sil (yonetici)",
        deleteMessage: "\"{{title}}\" silinsin mi? Bu islem geri alinamaz.",
        deleting: "Siliniyor...",
        titleRequired: "Baslik zorunludur.",
        yearInvalid: "Yil 1900 ile 2100 arasinda olmalidir.",
        dateRequired: "Yayin tarihi zorunludur.",
        publisherRequired: "Kitaplar/bolumler icin yayinci zorunludur.",
        journalRequired: "Dergi / konferans basligi zorunludur.",
        pdfTooLarge: "PDF en fazla 10 MB olmalidir.",
        pdfOnly: "Yalnizca PDF dosyalarina izin verilir.",
        typeJournalArticle: "Dergi makalesi",
        typeConferencePaper: "Konferans bildirisi",
        typeBook: "Kitap",
        typeBookChapter: "Kitap bolumu"
      }
    }
  },
  it: {
    translation: {
      common: {
        loading: "Caricamento...",
        menu: "Menu",
        dashboard: "Dashboard",
        myProfile: "Il mio profilo",
        adminPanel: "Pannello admin",
        projects: "Progetti",
        publications: "Pubblicazioni",
        announcements: "Annunci",
        messages: "Messaggi",
        matching: "Matching",
        autoMatching: "Matching automatico",
        connections: "Connessioni",
        requests: "Richieste",
        logout: "Disconnetti",
        language: "Lingua",
        view: "Apri",
        manage: "Gestisci",
        editProfile: "Modifica profilo",
        close: "Chiudi",
        message: "Messaggio",
        refresh: "Aggiorna",
        search: "Cerca",
        reset: "Reimposta",
        previous: "Precedente",
        next: "Successivo",
        any: "Qualsiasi",
        yes: "Si",
        no: "No",
        connect: "Connetti",
        connected: "Connesso",
        pending: "In attesa",
        send: "Invia",
        sending: "Invio in corso...",
        upload: "Carica",
        replace: "Sostituisci",
        open: "Apri",
        remove: "Rimuovi",
        add: "Aggiungi",
        edit: "Modifica",
        delete: "Elimina",
        cancel: "Annulla",
        save: "Salva",
        create: "Crea",
        details: "Dettagli",
        profile: "Profilo",
        pdf: "PDF",
        link: "Link",
        searching: "Ricerca in corso...",
        unknownUser: "Utente sconosciuto",
        description: "Descrizione",
        title: "Titolo",
        website: "Sito web",
        linkedin: "LinkedIn",
        github: "GitHub",
        or: "OPPURE",
        orContinueWith: "OPPURE CONTINUA CON"
      },
      theme: {
        day: "Giorno",
        night: "Notte",
        switchToLight: "Passa alla modalita chiara",
        switchToDark: "Passa alla modalita scura"
      },
      brand: {
        name: "Youngreenteco",
        tagline: "Connetti e cresci"
      },
      sections: {
        admin: "Admin",
        explore: "Esplora"
      },
      roles: {
        ADMIN: "Amministratore",
        SUPERVISOR: "Supervisore",
        ENTREPRENEURS: "Imprenditori",
        MENTORS: "Mentori",
        INVESTORS: "Investitori",
        MANUFACTURERS: "Produttori"
      },
      layout: {
        defaultTitle: "Pagina",
        dashboardSubtitle: "Panoramica e suggerimenti",
        adminSubtitle: "Gestisci gli account della piattaforma",
        openMenu: "Apri menu"
      },
      home: {
        hero: {
          line1: "Rete europea",
          line2: "dei giovani",
          line3: "imprenditori green."
        },
        subtitle: "Collega imprenditori, mentori, investitori e produttori in un unico posto.",
        welcome: "Benvenuto",
        choosePath: "Scegli dove vuoi andare.",
        loginTitle: "Accedi",
        loginText: "Entra nel tuo spazio di lavoro",
        registerTitle: "Registrati",
        registerText: "Crea un nuovo account",
        partners: "Questa piattaforma e stata realizzata con il supporto dei nostri partner.",
        contact: "Per domande, contatta:"
      },
      login: {
        title: "Bentornato",
        subtitle: "Inserisci le tue credenziali per accedere al tuo spazio di lavoro",
        emailLabel: "Indirizzo email",
        emailPlaceholder: "nome@example.com",
        passwordLabel: "Password",
        signIn: "Accedi",
        signingIn: "Accesso in corso...",
        registerPrompt: "Non hai un account?",
        registerNow: "Registrati ora",
        googleFailed: "Autenticazione Google non riuscita. Riprova.",
        errors: {
          invalidCredentials: "Email o password non valide.",
          loginFailed: "Accesso non riuscito. Riprova.",
          unexpected: "Si e verificato un errore imprevisto. Riprova."
        },
        features: {
          entrepreneursTitle: "Imprenditori",
          entrepreneursText: "Connettiti con mentori, investitori e produttori in linea con la tua fase di crescita.",
          mentorsTitle: "Mentori",
          mentorsText: "Supporta i founder con competenze mirate e guida strutturata.",
          investorsTitle: "Investitori",
          investorsText: "Scopri startup selezionate per settore, trazione e livello di maturita.",
          manufacturersTitle: "Produttori",
          manufacturersText: "Collabora con startup pronte per prototipazione e produzione."
        }
      },
      register: {
        platformTitle: "Rete europea dei giovani imprenditori green",
        platformSubtitle: "Piattaforma ecosistema Younggreenteco",
        chooseRole: "Scegli il tuo ruolo",
        basicInfo: "Informazioni di base",
        firstName: "Nome",
        lastName: "Cognome",
        email: "Email",
        password: "Password",
        createAccount: "Crea account",
        alreadyHaveAccount: "Hai gia un account?",
        logIn: "Accedi",
        continueWithGoogle: "Seleziona un ruolo per continuare con Google",
        alerts: {
          selectRoleFirst: "Seleziona un ruolo prima di continuare con Google",
          googleFailed: "Registrazione con Google non riuscita",
          authFailed: "Autenticazione Google non riuscita"
        },
        errors: {
          selectRole: "Seleziona un ruolo",
          invalidEmail: "Indirizzo email non valido",
          passwordUppercase: "La password deve contenere almeno una lettera maiuscola",
          passwordBang: "La password deve contenere il carattere !",
          registrationFailed: "Registrazione non riuscita. Riprova."
        }
      },
      dashboard: {
        loading: "Caricamento dashboard...",
        welcome: "Bentornato, {{name}}",
        intro: "Panoramica rapida della tua attivita e delle funzioni della piattaforma.",
        overview: "Panoramica",
        upToDate: "Aggiornato",
        quickGuide: "Guida rapida",
        quickGuideSubtitle: "Come funziona la piattaforma",
        stats: {
          connections: "Connessioni",
          connectionsHint: "Persone con cui sei connesso",
          projects: "Progetti",
          projectsHint: "I progetti che hai creato",
          publications: "Pubblicazioni",
          publicationsHint: "I tuoi lavori pubblicati"
        },
        steps: {
          profileTitle: "Completa il tuo profilo",
          profileText: "Un profilo dettagliato migliora matching e visibilita.",
          usersTitle: "Trova utenti compatibili",
          usersText: "Usa Matching o Auto Matching per scoprire persone rilevanti.",
          connectionsTitle: "Crea connessioni",
          connectionsText: "Invia richieste, accetta inviti e collabora.",
          projectsTitle: "Crea progetti",
          projectsText: "Aggiungi progetti per mostrare il tuo lavoro e attirare collaboratori.",
          publicationsTitle: "Aggiungi pubblicazioni",
          publicationsText: "Condividi risultati di ricerca e carica documenti correlati."
        }
      },
      profile: {
        loading: "Caricamento profilo...",
        title: "Il mio profilo",
        subtitle: "Aggiorna i dettagli e le preferenze del profilo. Le modifiche vengono salvate automaticamente.",
        saveChanges: "Salva modifiche",
        savingButton: "Salvataggio...",
        saveAutomatic: "Salvataggio automatico...",
        saveError: "Salvataggio automatico non riuscito",
        savePending: "Ci sono modifiche non salvate...",
        saveComplete: "Tutte le modifiche sono state salvate",
        savedAt: "Salvato automaticamente alle {{time}}",
        saved: "Profilo salvato.",
        saveFailed: "Salvataggio del profilo non riuscito.",
        autosaveFailedLocal: "Il salvataggio automatico non e riuscito. Le modifiche sono ancora solo locali.",
        uploadingPhoto: "Caricamento foto...",
        photoUpdated: "Foto profilo aggiornata.",
        photoFailed: "Caricamento foto non riuscito.",
        uploadingCv: "Caricamento CV...",
        cvUploaded: "CV caricato.",
        cvFailed: "Caricamento CV non riuscito.",
        cvOpenFailed: "Impossibile aprire il CV.",
        header: "Panoramica profilo",
        headerTip: "Il tuo avatar e un indicatore rapido della completezza del profilo.",
        details: "Dettagli profilo",
        detailsTip: "Informazioni di base visibili pubblicamente: headline, bio, localita, affiliazione, professione e facolta.",
        collaboration: "Collaborazione",
        collaborationTip: "Disponibilita, livello di esperienza e preferenze di collaborazione.",
        expertise: "Competenze",
        expertiseTip: "Aggiungi aree di competenza e una breve descrizione per aiutare gli altri a capire le tue capacita.",
        resources: "Laboratori / Risorse",
        resourcesTip: "Facoltativo: aggiungi link a laboratori, strumenti, repository, articoli o dataset.",
        companies: "Aziende",
        companiesTip: "Aggiungi una o piu aziende e i loro settori. Puoi lasciare vuoto.",
        links: "Link esterni",
        linksTip: "Aggiungi link come LinkedIn, GitHub o sito web per mostrare il tuo lavoro.",
        profileStrength: "Forza del profilo",
        professionalHeadline: "Il tuo titolo professionale",
        uploadProfilePhotoAria: "Carica foto profilo",
        openProfilePhotoAria: "Caricamento foto profilo",
        changePhoto: "Cambia foto",
        uploadPhoto: "Carica foto",
        uploading: "Caricamento...",
        imageUploading: "Caricamento immagine in corso...",
        imageRecommended: "Consigliato PNG, JPG o WEBP.",
        replaceCv: "Sostituisci CV",
        uploadCv: "Carica CV",
        viewCv: "Apri CV",
        noCv: "Nessun CV caricato",
        cvReady: "CV caricato e pronto da aprire.",
        documentUploading: "Caricamento documento in corso...",
        headline: "Headline",
        bio: "Bio",
        bioPlaceholder: "Aggiungi tutte le informazioni rilevanti su background, competenze, progetti, pubblicazioni e obiettivi di collaborazione.",
        charactersLeft: "{{count}} caratteri rimanenti",
        country: "Paese",
        city: "Citta",
        affiliation: "Affiliazione",
        profession: "Professione",
        university: "Universita",
        availability: "Disponibilita",
        experienceLevel: "Livello di esperienza",
        fullTime: "Tempo pieno",
        partTime: "Part time",
        weekends: "Weekend",
        junior: "Junior",
        mid: "Mid",
        senior: "Senior",
        openToProjects: "Disponibile per progetti",
        openToMentoring: "Disponibile per mentoring",
        addExpertiseHint: "Aggiungi almeno un'area per farti trovare dagli altri.",
        expertArea: "Area di competenza",
        expertAreaPlaceholder: "Cerca o aggiungi un'area di competenza",
        addExpertise: "+ Aggiungi competenza",
        resourceHint: "Facoltativo: aggiungi link a laboratori, strumenti, articoli o repository.",
        resourceUrl: "URL",
        addResource: "+ Aggiungi risorsa",
        companyHint: "Facoltativo: aggiungi un'azienda se rappresenti un'organizzazione.",
        companyName: "Nome azienda",
        companyDescription: "Descrizione azienda",
        domains: "Settori",
        addCompany: "+ Aggiungi azienda"
      },
      picker: {
        searchOrAdd: "Cerca o aggiungi...",
        pressEnterToAdd: "Premi Invio per aggiungere se non e presente nell'elenco."
      },
      accountSettings: {
        title: "Impostazioni account",
        cooldown: "Puoi cambiare di nuovo il nome dopo: {{date}}",
        firstName: "Nome",
        lastName: "Cognome",
        cancel: "Annulla",
        save: "Salva",
        saving: "Salvataggio...",
        saved: "Salvato.",
        taken: "Questo nome e gia in uso. Usa una combinazione diversa di nome + cognome.",
        cooldownError: "Puoi cambiare di nuovo il nome dopo il periodo di attesa di 14 giorni.",
        invalid: "Nome non valido.",
        genericError: "Qualcosa e andato storto. Riprova."
      },
      profileModal: {
        title: "Profilo",
        profession: "Professione",
        faculty: "Facolta",
        university: "Universita",
        bio: "Bio",
        collaborations: "Collaborazioni",
        expertise: "Competenze",
        resources: "Risorse",
        companies: "Aziende",
        cv: "CV",
        openCv: "Apri CV",
        links: "Link"
      },
      matching: {
        loadFailed: "Impossibile caricare i profili.",
        profileLoadFailed: "Impossibile caricare il profilo.",
        conversationFailed: "Impossibile avviare la conversazione.",
        title: "Matching",
        subtitle: "Sfoglia i profili e filtra per competenze e disponibilita.",
        sortBy: "Ordina per",
        sortName: "Nome",
        sortExpertise: "Area di competenza",
        sortAvailability: "Disponibilita",
        sortProjects: "Disponibile per progetti",
        sortMentoring: "Disponibile per mentoring",
        sortExperience: "Livello di esperienza",
        asc: "Asc",
        desc: "Desc",
        filterName: "Nome",
        searchByName: "Cerca per nome",
        filterExpertise: "Area di competenza",
        expertisePlaceholder: "Area di competenza",
        filterAvailability: "Disponibilita",
        filterExperience: "Esperienza",
        filterProjects: "Disponibile per progetti",
        filterMentoring: "Disponibile per mentoring",
        empty: "Nessun profilo corrispondente.",
        viewProfile: "Apri profilo",
        requested: "Richiesto",
        reviewRequest: "Controlla richiesta",
        requestSent: "Richiesta inviata.",
        requestFailed: "Impossibile inviare la richiesta.",
        openProfile: "Apri profilo",
        pageSummary: "Pagina {{page}} / {{total}} - {{count}} profili"
      },
      autoMatching: {
        loadFailed: "Impossibile caricare i match automatici.",
        profileLoadFailed: "Impossibile caricare il profilo.",
        conversationFailed: "Impossibile avviare la conversazione.",
        requestSent: "Richiesta di connessione inviata.",
        requestFailed: "Impossibile inviare la richiesta di connessione.",
        title: "Matching automatico",
        subtitle: "Controlla i match automatici piu forti e connettiti piu rapidamente.",
        empty: "Nessun risultato.",
        whyMatch: "Perche siete compatibili",
        noDetails: "Nessun dettaglio disponibile sul match.",
        affiliation: "Affiliazione",
        experience: "Esperienza",
        expertise: "Competenze",
        collaboration: "Collaborazione",
        bio: "Bio",
        totalScore: "Punteggio totale",
        unknown: "Sconosciuto",
        profileButton: "Profilo",
        slideAria: "Vai alla slide {{index}}",
        previous: "Precedente",
        next: "Successivo"
      },
      connectionRequests: {
        loadFailed: "Impossibile caricare le richieste.",
        acceptFailed: "Impossibile accettare la richiesta.",
        rejectFailed: "Impossibile rifiutare la richiesta.",
        title: "Richieste di connessione",
        subtitle: "Qui puoi accettare o rifiutare le richieste di connessione. Per inviarne una nuova, vai su Matching o apri un profilo.",
        empty: "Nessuna richiesta in attesa. Se vuoi collegarti a qualcuno, vai su Matching e invia una richiesta.",
        accept: "Accetta",
        reject: "Rifiuta",
        user: "Utente"
      },
      connections: {
        title: "Connessioni",
        subtitle: "Le persone con cui sei connesso. Da qui puoi aprire i profili o avviare una conversazione.",
        empty: "Non ci sono ancora connessioni. Vai su Matching per scoprire persone e inviare richieste di connessione.",
        loadFailed: "Impossibile caricare le connessioni.",
        profileLoadFailed: "Impossibile caricare il profilo.",
        conversationFailed: "Impossibile avviare la conversazione."
      },
      announcements: {
        title: "Annunci",
        subtitle: "Aggiornamenti da persone e progetti, prima i piu recenti.",
        refreshing: "Aggiornamento...",
        composerPlaceholder: "Condividi un aggiornamento...",
        previewAlt: "Anteprima immagine",
        removeImage: "Rimuovi immagine",
        attachPhoto: "Allega una foto",
        photo: "Foto",
        postUpdate: "Pubblica aggiornamento",
        uploading: "Caricamento...",
        posting: "Pubblicazione...",
        post: "Pubblica",
        loadMore: "Carica altro",
        loadFailed: "Impossibile caricare gli annunci.",
        profileLoadFailed: "Impossibile caricare il profilo.",
        imageFileOnly: "Seleziona un file immagine.",
        imageTooLarge: "L'immagine e troppo grande (massimo 8 MB).",
        posted: "Pubblicato.",
        postFailed: "Pubblicazione non riuscita.",
        commentAdded: "Commento aggiunto.",
        commentFailed: "Impossibile aggiungere il commento.",
        commentDeleted: "Commento eliminato.",
        commentDeleteFailed: "Impossibile eliminare il commento.",
        deleteFallback: "questo post",
        deleted: "Post eliminato.",
        deleteFailed: "Impossibile eliminare il post.",
        conversationFailed: "Impossibile avviare la conversazione.",
        deleteTitle: "Elimina post",
        deleteMessage: "Eliminare \"{{title}}\"? L'azione non puo essere annullata.",
        deleting: "Eliminazione...",
        deletePost: "Elimina post",
        deleteComment: "Elimina commento",
        postImageAlt: "Immagine del post",
        likesCount: "{{count}} mi piace",
        commentsCount: "{{count}} commenti",
        like: "Mi piace",
        comment: "Commenta",
        commentPlaceholder: "Scrivi un commento..."
      },
      adminUsers: {
        usersLoadFailed: "Impossibile caricare gli utenti.",
        userUpdated: "I dettagli dell'utente sono stati aggiornati.",
        userUpdateFailed: "Impossibile aggiornare i dettagli dell'utente.",
        userDeleted: "L'account utente e stato eliminato.",
        userDeleteFailed: "Impossibile eliminare l'utente.",
        eyebrow: "Strumenti amministratore",
        title: "Gestione utenti",
        subtitle: "L'accesso e limitato agli account con ruolo backend ADMIN. I supervisor possono gestire gli account amministratore. Gli amministratori possono gestire solo gli utenti standard.",
        totalUsers: "Utenti totali",
        adminAccounts: "Account admin",
        projects: "Progetti",
        publications: "Pubblicazioni",
        announcements: "Annunci",
        pendingRequests: "Richieste in attesa",
        roleBreakdown: "Distribuzione ruoli",
        activeRoles: "{{count}} ruoli attivi",
        usersCount: "{{count}} utenti",
        searchUsers: "Cerca utenti",
        searchPlaceholder: "Nome o email",
        currentAccount: "Account corrente: {{name}}",
        loadingUsers: "Caricamento utenti...",
        noUsers: "Nessun utente corrisponde alla ricerca.",
        currentAccountBadge: "Account corrente",
        userId: "ID utente #{{id}}",
        selfLocked: "Il tuo account admin e bloccato in questo pannello per mantenere valida la sessione corrente.",
        supervisorProtected: "Gli account supervisor sono protetti e devono essere gestiti manualmente fuori da questo pannello.",
        adminRestricted: "Gli amministratori non possono gestire account amministratore o supervisor.",
        firstName: "Nome",
        lastName: "Cognome",
        email: "Email",
        role: "Ruolo",
        saveChanges: "Salva modifiche",
        deleteTitle: "Eliminare l'account utente?",
        deleteMessage: "Stai per eliminare {{name}}. Verranno eliminati anche dati profilo, progetti, pubblicazioni, messaggi e annunci collegati.",
        deleting: "Eliminazione...",
        deletePermanently: "Elimina definitivamente",
        roles: {
          citizen: "Cittadino",
          entrepreneurs: "Imprenditori",
          mentors: "Mentori",
          investors: "Investitori",
          manufacturers: "Produttori",
          admin: "Amministratore",
          supervisor: "Supervisor"
        }
      },
      messagesPage: {
        conversationsLoadFailed: "Impossibile caricare le conversazioni.",
        messagesLoadFailed: "Impossibile caricare i messaggi.",
        pdfOnly: "Sono consentiti solo file PDF.",
        pdfTooLarge: "PDF troppo grande (massimo 25MB).",
        sendFailed: "Impossibile inviare il messaggio.",
        downloadFailed: "Impossibile scaricare l'allegato.",
        removedToast: "La conversazione con {{name}} e stata rimossa dalla tua lista.",
        removeFailed: "Impossibile rimuovere la conversazione.",
        title: "Messaggi",
        subtitle: "Le tue conversazioni. Se non hai messaggi, inizia collegandoti con qualcuno.",
        searchPlaceholder: "Cerca...",
        noResults: "Nessun risultato.",
        noConversations: "Nessuna conversazione. Vai su Connections e avvia un messaggio.",
        selectConversation: "Seleziona una conversazione",
        chooseConversation: "Scegli una conversazione per iniziare a chattare.",
        selectFromLeft: "Seleziona una conversazione a sinistra oppure vai su Connections per iniziarne una.",
        loadingMessages: "Caricamento messaggi...",
        you: "Tu",
        openPdf: "Apri PDF",
        attachPdf: "Allega PDF",
        pdfOptional: "PDF opzionale",
        writeMessage: "Scrivi un messaggio...",
        selectConversationFirst: "Seleziona prima una conversazione",
        removeTitle: "Rimuovi conversazione",
        removeMessage: "Rimuovere la conversazione con \"{{name}}\" dalla tua lista?"
      },
      projects: {
        title: "Progetti",
        subtitle: "Crea i tuoi progetti ed esplora quelli pubblicati dagli altri.",
        myProjects: "I miei progetti",
        exploreProjects: "Esplora progetti",
        explore: "Esplora",
        newProject: "+ Nuovo progetto",
        addProject: "Aggiungi progetto",
        acronym: "Acronimo",
        searchPlaceholder: "Cerca...",
        noProjectsYet: "Nessun progetto ancora.",
        noProjects: "Nessun progetto.",
        abstract: "Abstract",
        timeline: "Tempistica:",
        extension: "Est:",
        startDate: "Data inizio",
        endDate: "Data fine",
        extensionEnd: "Possibile fine proroga",
        contractNumber: "Numero contratto",
        coordinator: "Coordinatore",
        partners: "Partner",
        partner: "Partner",
        addPartner: "Aggiungi partner",
        removePartner: "Rimuovi partner",
        deleteTitle: "Elimina progetto",
        deleteMessage: "Eliminare \"{{title}}\"? L'azione non puo essere annullata.",
        deleting: "Eliminazione...",
        loadProfileFailed: "Impossibile caricare il profilo.",
        viewProfile: "Apri profilo"
      },
      publications: {
        title: "Pubblicazioni",
        subtitle: "Aggiungi le tue pubblicazioni ed esplora quelle pubblicate dagli altri.",
        myPublications: "Le mie pubblicazioni",
        explore: "Esplora",
        newPublication: "+ Nuova pubblicazione",
        searchPublications: "Cerca pubblicazioni",
        searchPlaceholder: "Cerca per titolo, autori, rivista, DOI o utente...",
        noPublicationsYet: "Nessuna pubblicazione ancora.",
        noResults: "Nessun risultato.",
        type: "Tipo",
        publicationTitle: "Titolo",
        publicationTitlePlaceholder: "Titolo della pubblicazione",
        authors: "Autori",
        externalLink: "Link esterno",
        publicationDate: "Data di pubblicazione",
        year: "Anno",
        keywords: "Parole chiave",
        journalConferenceTitle: "Titolo rivista / conferenza",
        journalConference: "Rivista / conferenza",
        volumeIssue: "Volume / fascicolo",
        pages: "Pagine",
        doi: "DOI",
        publisher: "Editore",
        pdfUpload: "PDF (max 10 MB)",
        replacePdf: "Sostituisci PDF (max 10 MB)",
        openCurrentPdf: "Apri PDF corrente",
        saved: "Pubblicazione salvata.",
        saveFailed: "Impossibile salvare la pubblicazione.",
        updated: "Pubblicazione aggiornata.",
        updateFailed: "Impossibile aggiornare la pubblicazione.",
        deleted: "Pubblicazione eliminata.",
        deleteFailed: "Impossibile eliminare la pubblicazione.",
        openPdfFailed: "Impossibile aprire il PDF.",
        loadFailed: "Impossibile caricare le pubblicazioni.",
        profileLoadFailed: "Impossibile caricare il profilo.",
        conversationFailed: "Impossibile avviare la conversazione.",
        deleteTitle: "Elimina pubblicazione",
        deleteAdminTitle: "Elimina pubblicazione (admin)",
        deleteMessage: "Eliminare \"{{title}}\"? L'azione non puo essere annullata.",
        deleting: "Eliminazione...",
        titleRequired: "Il titolo e obbligatorio.",
        yearInvalid: "L'anno deve essere compreso tra 1900 e 2100.",
        dateRequired: "La data di pubblicazione e obbligatoria.",
        publisherRequired: "L'editore e obbligatorio per libri/capitoli.",
        journalRequired: "Il titolo della rivista / conferenza e obbligatorio.",
        pdfTooLarge: "Il PDF deve essere al massimo di 10 MB.",
        pdfOnly: "Sono consentiti solo file PDF.",
        typeJournalArticle: "Articolo di rivista",
        typeConferencePaper: "Articolo di conferenza",
        typeBook: "Libro",
        typeBookChapter: "Capitolo di libro"
      }
    }
  },
  is: {
    translation: {
      common: {
        loading: "Hled...",
        menu: "Valmynd",
        dashboard: "Yfirlit",
        myProfile: "Profilinn minn",
        adminPanel: "Stjornbord",
        projects: "Verkefni",
        publications: "Birtingar",
        announcements: "Tilkynningar",
        messages: "Skilabod",
        matching: "Samsvorun",
        autoMatching: "Sjalfvirk samsvorun",
        connections: "Tengingar",
        requests: "Beidnir",
        logout: "Skra ut",
        language: "Tungumal",
        view: "Skoda",
        manage: "Stjorna",
        editProfile: "Breyta profili",
        close: "Loka",
        message: "Skilabod",
        refresh: "EndurhlaÃ°a",
        search: "Leita",
        reset: "Endurstilla",
        previous: "Fyrri",
        next: "Naesti",
        any: "Hvad sem er",
        yes: "Ja",
        no: "Nei",
        connect: "Tengjast",
        connected: "Tengt",
        pending: "IBid",
        send: "Senda",
        sending: "Sendi...",
        upload: "HlaÃ°a upp",
        replace: "Skipta ut",
        open: "Opna",
        remove: "FjarlÃ¦gja",
        add: "Baeta vid",
        edit: "Breyta",
        delete: "Eyda",
        cancel: "Haetta vid",
        save: "Vista",
        create: "Bua til",
        details: "Nanar",
        profile: "Profil",
        pdf: "PDF",
        link: "Tengill",
        searching: "Leita...",
        unknownUser: "Okunnur notandi",
        description: "Lysing",
        title: "Titill",
        website: "Vefsida",
        linkedin: "LinkedIn",
        github: "GitHub",
        or: "EDA",
        orContinueWith: "EDA HALDA AFRAM MED"
      },
      theme: {
        day: "Dagur",
        night: "Nott",
        switchToLight: "Skipta i ljost vidmot",
        switchToDark: "Skipta i dokkt vidmot"
      },
      brand: {
        name: "Youngreenteco",
        tagline: "Tengstu og vaxdu"
      },
      sections: {
        admin: "Stjornun",
        explore: "Kanna"
      },
      roles: {
        ADMIN: "Stjornandi",
        SUPERVISOR: "Eftirlitsadili",
        ENTREPRENEURS: "Frumkvodlar",
        MENTORS: "Leidbeinendur",
        INVESTORS: "Fjarfestar",
        MANUFACTURERS: "Framleidendur"
      },
      layout: {
        defaultTitle: "Sida",
        dashboardSubtitle: "Yfirlit og tillogur",
        adminSubtitle: "Stjorna reikningum a vettvanginum",
        openMenu: "Opna valmynd"
      },
      home: {
        hero: {
          line1: "Evropskt net",
          line2: "ungra graenna",
          line3: "frumkvodla."
        },
        subtitle: "Tengdu frumkvodla, leidbeinendur, fjarfesta og framleidendur a einum stad.",
        welcome: "Velkomin",
        choosePath: "Veldu hvert thu vilt fara.",
        loginTitle: "Skra inn",
        loginText: "Fa adgang ad vinnusvaedinu thinu",
        registerTitle: "Nyskraning",
        registerText: "Bua til nyjan reikning",
        partners: "Thessi vettvangur var byggdur med studningi samstarfsadila okkar.",
        contact: "Fyrir spurningar, hafdu samband:"
      },
      login: {
        title: "Velkomin aftur",
        subtitle: "Sladu inn upplysingu til ad fa adgang ad vinnusvaedinu thinu",
        emailLabel: "Netfang",
        emailPlaceholder: "nafn@example.com",
        passwordLabel: "Lykilord",
        signIn: "Skra inn",
        signingIn: "Skra inn...",
        registerPrompt: "Ertu ekki med reikning?",
        registerNow: "NyskraÃ°u thig nuna",
        googleFailed: "Google audkenning mistokst. Reyndu aftur.",
        errors: {
          invalidCredentials: "Netfang eda lykilord er rangt.",
          loginFailed: "Innskraning mistokst. Reyndu aftur.",
          unexpected: "Ovaent villa kom upp. Reyndu aftur."
        },
        features: {
          entrepreneursTitle: "Frumkvodlar",
          entrepreneursText: "Tengstu leidbeinendum, fjarfestum og framleidendum sem passa vaxtarstigi thinu.",
          mentorsTitle: "Leidbeinendur",
          mentorsText: "Stydu stofnendur med markvissri serfraedi og skipulagdri handleidslu.",
          investorsTitle: "Fjarfestar",
          investorsText: "Finndu valin sprotafyrirtaeki eftir geira, framvindu og undirbuningi.",
          manufacturersTitle: "Framleidendur",
          manufacturersText: "Vinnid med sprotum sem eru tilbunir i frumgerd og framleidslu."
        }
      },
      register: {
        platformTitle: "Evropskt net ungra graenna frumkvodla",
        platformSubtitle: "Younggreenteco vistkerfisvettvangur",
        chooseRole: "Veldu hlutverk",
        basicInfo: "Grunnupplysingar",
        firstName: "Fornafn",
        lastName: "Eftirnafn",
        email: "Netfang",
        password: "Lykilord",
        createAccount: "Bua til reikning",
        alreadyHaveAccount: "Ertu thegar med reikning?",
        logIn: "Skra inn",
        continueWithGoogle: "Veldu hlutverk til ad halda afram med Google",
        alerts: {
          selectRoleFirst: "Veldu fyrst hlutverk adur en thu heldur afram med Google",
          googleFailed: "Google nyskraning mistokst",
          authFailed: "Google audkenning mistokst"
        },
        errors: {
          selectRole: "Veldu hlutverk",
          invalidEmail: "Ogildugt netfang",
          passwordUppercase: "Lykilord verdur ad innihalda ad minnsta kosti einn storan staf",
          passwordBang: "Lykilord verdur ad innihalda ! merkid",
          registrationFailed: "Nyskraning mistokst. Reyndu aftur."
        }
      },
      dashboard: {
        loading: "Hled yfirlit...",
        welcome: "Velkomin aftur, {{name}}",
        intro: "Hradyfirlit yfir virkni thina og eiginleika vettvangsins.",
        overview: "Yfirlit",
        upToDate: "Uppfaert",
        quickGuide: "Fljotleg leidsoegn",
        quickGuideSubtitle: "Hvernig vettvangurinn virkar",
        stats: {
          connections: "Tengingar",
          connectionsHint: "Folkid sem thu ert tengdur vid",
          projects: "Verkefni",
          projectsHint: "Verkefnin sem thu hefur buid til",
          publications: "Birtingar",
          publicationsHint: "Birt verk eftir thig"
        },
        steps: {
          profileTitle: "KlaraÃ°u profilinn thinn",
          profileText: "Itarlegur profill baetir samsvorun og synileika.",
          usersTitle: "Finndu samhaefa notendur",
          usersText: "Notadu Matching eda Auto Matching til ad finna vidadandi einstaklinga.",
          connectionsTitle: "Byggdu upp tengingar",
          connectionsText: "Sendu beidnir, samÃ¾ykktu bod og hafdu samstarf.",
          projectsTitle: "Buadu til verkefni",
          projectsText: "Baettu vid verkefnum til ad syna verkin thin og lada ad samstarfsadilum.",
          publicationsTitle: "Baettu vid birtingum",
          publicationsText: "Deildu rannsoknanidurstodum og hladdu upp tengdum skjolum."
        }
      },
      profile: {
        loading: "Hled profil...",
        title: "Profilinn minn",
        subtitle: "Uppfaerdu profillinn og stillingar. Breytingar vistast sjalfkrafa.",
        saveChanges: "Vista breytingar",
        savingButton: "Vistar...",
        saveAutomatic: "Sjalfvirk vistun...",
        saveError: "Sjalfvirk vistun mistokst",
        savePending: "Ovistar breytingar...",
        saveComplete: "Allar breytingar vistaÃ°ar",
        savedAt: "Sjalfkrafa vistaÃ° kl. {{time}}",
        saved: "Profil vistaÃ°ur.",
        saveFailed: "Mistokst aÃ° vista profil.",
        autosaveFailedLocal: "Sjalfvirk vistun mistokst. Breytingarnar eru enn bara a thinni tolvu.",
        uploadingPhoto: "Hled inn mynd...",
        photoUpdated: "Profilmynd uppfaerd.",
        photoFailed: "Mistokst ad hlaÃ°a inn mynd.",
        uploadingCv: "Hled inn ferilskra...",
        cvUploaded: "Ferilskra hlodin upp.",
        cvFailed: "Mistokst ad hlaÃ°a inn ferilskra.",
        cvOpenFailed: "Ekki toekst ad opna ferilskra.",
        header: "Yfirlit profils",
        headerTip: "Avatarinn thinn og fljotlegt mat a styrk profilsins.",
        details: "ProfilupplÃ½singar",
        detailsTip: "Grunnupplysingar sem sjast opinberlega: headline, bio, stadsetning, tenging, starf og deild.",
        collaboration: "Samstarf",
        collaborationTip: "FramboÃ°, reynslustig og samstarfsosk.",
        expertise: "Sersvid",
        expertiseTip: "Baettu vid sersvidum og stuttri lysingu svo folk skilji styrkleika thina.",
        resources: "Rannsoknarstofur / Audlindir",
        resourcesTip: "Valfrjalsar tengingar i rannsÃ³knarstofur, verkfaeri, geymslur, greinar eda gagnasofn.",
        companies: "Fyrirtaeki",
        companiesTip: "Baettu vid einu eda fleiri fyrirtÃ¦kjum og svidum theirra. Thu maett skilja this eftir tomt.",
        links: "Ytri tenglar",
        linksTip: "Baettu vid LinkedIn, GitHub eda vefsidu svo adrir geti sed verkin thin.",
        profileStrength: "Styrkur profils",
        professionalHeadline: "Fagleg fyrirsogn thin",
        uploadProfilePhotoAria: "HlaÃ°a inn profilmynd",
        openProfilePhotoAria: "Hled inn profilmynd",
        changePhoto: "Breyta mynd",
        uploadPhoto: "HlaÃ°a inn mynd",
        uploading: "Hled inn...",
        imageUploading: "MyndhleÃ°sla i gangi...",
        imageRecommended: "Maelt med PNG, JPG eda WEBP.",
        replaceCv: "Skipta ut ferilskra",
        uploadCv: "HlaÃ°a inn ferilskra",
        viewCv: "Syna ferilskra",
        noCv: "Engin ferilskra hlodin upp",
        cvReady: "Ferilskra er hlodin upp og tilbun til opnunar.",
        documentUploading: "SkjalhleÃ°sla i gangi...",
        headline: "Headline",
        bio: "Bio",
        bioPlaceholder: "Baettu vid ollum mikilvaegum upplÃ½singum um bakgrunn, sersvid, verkefni, birtingar og samstarfsmarkmid.",
        charactersLeft: "{{count}} stafir eftir",
        country: "Land",
        city: "Borg",
        affiliation: "Tenging",
        profession: "Starf",
        university: "Haskoli",
        availability: "FramboÃ°",
        experienceLevel: "Reynslustig",
        fullTime: "Fullt starf",
        partTime: "Hlutastarf",
        weekends: "Helgar",
        junior: "Junior",
        mid: "Mid",
        senior: "Senior",
        openToProjects: "Opinn fyrir verkefnum",
        openToMentoring: "Opinn fyrir handleidslu",
        addExpertiseHint: "Baettu vid ad minnsta kosti einu sersvidi svo adrir geti fundid thig.",
        expertArea: "Sersvid",
        expertAreaPlaceholder: "Leita eda baeta vid sersvidi",
        addExpertise: "+ Baeta vid sersvidi",
        resourceHint: "Valfrjals: baettu vid tenglum i rannsÃ³knarstofur, verkfaeri, greinar eda geymslur.",
        resourceUrl: "URL",
        addResource: "+ Baeta vid audlind",
        companyHint: "Valfrjals: baettu vid fyrirtÃ¦ki ef thu kemur fram fyrir stofnun.",
        companyName: "Heiti fyrirtÃ¦kis",
        companyDescription: "Lysing fyrirtÃ¦kis",
        domains: "Svid",
        addCompany: "+ Baeta vid fyrirtÃ¦ki"
      },
      picker: {
        searchOrAdd: "Leita eda baeta vid...",
        pressEnterToAdd: "Yttu a Enter til ad baeta vid ef thad er ekki a listanum."
      },
      accountSettings: {
        title: "Stillingar reiknings",
        cooldown: "Thu getur breytt nafninu aftur eftir: {{date}}",
        firstName: "Fornafn",
        lastName: "Eftirnafn",
        cancel: "Haetta vid",
        save: "Vista",
        saving: "Vistar...",
        saved: "VistaÃ°.",
        taken: "Thetta nafn er thegar i notkun. Veldu annat fornafn + eftirnafn.",
        cooldownError: "Thu getur breytt nafninu aftur eftir 14 daga bidtima.",
        invalid: "Ogilt nafn.",
        genericError: "Eitthvad for urskeidis. Reyndu aftur."
      },
      profileModal: {
        title: "Profil",
        profession: "Starf",
        faculty: "Deild",
        university: "Haskoli",
        bio: "Bio",
        collaborations: "Samstarf",
        expertise: "Sersvid",
        resources: "Audlindir",
        companies: "Fyrirtaeki",
        cv: "Ferilskra",
        openCv: "Opna ferilskra",
        links: "Tenglar"
      },
      matching: {
        loadFailed: "Ekki toekst ad hlaÃ°a profila.",
        profileLoadFailed: "Ekki toekst ad hlaÃ°a profili.",
        conversationFailed: "Ekki toekst ad hefja samtal.",
        title: "Samsvorun",
        subtitle: "Skodadu profila og siadu eftir sersvidi og frambodi.",
        sortBy: "Rada eftir",
        sortName: "Nafni",
        sortExpertise: "Sersvidi",
        sortAvailability: "Frambodi",
        sortProjects: "Opinn fyrir verkefnum",
        sortMentoring: "Opinn fyrir handleidslu",
        sortExperience: "Reynslustigi",
        asc: "Upp",
        desc: "Nid",
        filterName: "Nafn",
        searchByName: "Leita eftir nafni",
        filterExpertise: "Sersvid",
        expertisePlaceholder: "Sersvid",
        filterAvailability: "Frambod",
        filterExperience: "Reynsla",
        filterProjects: "Opinn fyrir verkefnum",
        filterMentoring: "Opinn fyrir handleidslu",
        empty: "Engir profilar fundust.",
        viewProfile: "Syna profil",
        requested: "Beidni send",
        reviewRequest: "Skoda beidni",
        requestSent: "Beidni send.",
        requestFailed: "Ekki toekst ad senda beidni.",
        openProfile: "Opna profil",
        pageSummary: "Sida {{page}} / {{total}} - {{count}} profiler"
      },
      autoMatching: {
        loadFailed: "Ekki toekst ad hlaÃ°a sjalfvirkar samsvaranir.",
        profileLoadFailed: "Ekki toekst ad hlaÃ°a profili.",
        conversationFailed: "Ekki toekst ad hefja samtal.",
        requestSent: "Tengibeidni send.",
        requestFailed: "Ekki toekst ad senda tengibeidni.",
        title: "Sjalfvirk samsvorun",
        subtitle: "Skodadu sterkustu sjalfvirku samsvaranirnar og tengstu hradar.",
        empty: "Engar nidurstodur.",
        whyMatch: "Af hverju thid passid saman",
        noDetails: "Engar upplysingar um samsvorun.",
        affiliation: "Tenging",
        experience: "Reynsla",
        expertise: "Sersvid",
        collaboration: "Samstarf",
        bio: "Bio",
        totalScore: "Heildarskor",
        unknown: "Okunnugt",
        profileButton: "Profil",
        slideAria: "Fara a skyggnu {{index}}",
        previous: "Fyrri",
        next: "Naesta"
      },
      connectionRequests: {
        loadFailed: "Ekki toekst ad hlaÃ°a beidnir.",
        acceptFailed: "Ekki toekst ad samÃ¾ykkja beidni.",
        rejectFailed: "Ekki toekst ad hafna beidni.",
        title: "Tengibeidnir",
        subtitle: "Her getur thu samÃ¾ykkt eda hafnad tengibeidnum. Til ad senda nyja beidni skaltu fara i Matching eda opna profil.",
        empty: "Engar beidnir i bid. Ef thu vilt tengjast einhverjum skaltu fara i Matching og senda beidni.",
        accept: "SamÃ¾ykkja",
        reject: "Hafna",
        user: "Notandi"
      },
      adminUsers: {
        usersLoadFailed: "Ekki toekst ad hlaa notendur.",
        userUpdated: "Notendaupplysingar voru uppfaerdar.",
        userUpdateFailed: "Ekki toekst ad uppfaera notendaupplysingar.",
        userDeleted: "Notandareikningi var eytt.",
        userDeleteFailed: "Ekki toekst ad eyda notanda.",
        eyebrow: "Stjornunarverkfaeri",
        title: "Notendastjornun",
        subtitle: "Adgangur er bundinn reikningum med backend hlutverkid ADMIN. Supervisor reikningar geta stjornad administrator reikningum. Administrator reikningar geta einungis stjornad venjulegum notendum.",
        totalUsers: "Heildarfjoldi notenda",
        adminAccounts: "Admin reikningar",
        projects: "Verkefni",
        publications: "Birtingar",
        announcements: "Tilkynningar",
        pendingRequests: "Bidandi beidnir",
        roleBreakdown: "Dreifing hlutverka",
        activeRoles: "{{count}} virk hlutverk",
        usersCount: "{{count}} notendur",
        searchUsers: "Leita ad notendum",
        searchPlaceholder: "Nafn eda netfang",
        currentAccount: "Nuverandi reikningur: {{name}}",
        loadingUsers: "Hled notendur...",
        noUsers: "Enginn notandi passar vid leitina.",
        currentAccountBadge: "Nuverandi reikningur",
        userId: "Notandaaukenni #{{id}}",
        selfLocked: "Thinn eigin admin reikningur er laestur i this panel svo nuverandi lota haldist gild.",
        supervisorProtected: "Supervisor reikningar eru verndadir og tharfnast handvirkrar stjornunar utan this panels.",
        adminRestricted: "Administrator reikningar geta ekki stjornad administrator eda supervisor reikningum.",
        firstName: "Fornafn",
        lastName: "Eftirnafn",
        email: "Netfang",
        role: "Hlutverk",
        saveChanges: "Vista breytingar",
        deleteTitle: "Eyda notandareikningi?",
        deleteMessage: "Thu ert ad fara ad eyda {{name}}. Thetta eydir einnig tengdum profilgognum, verkefnum, birtingum, skilabodum og tilkynningum.",
        deleting: "Eydi...",
        deletePermanently: "Eyda varanlega",
        roles: {
          citizen: "Borgari",
          entrepreneurs: "Frumkvodlar",
          mentors: "Leidbeinendur",
          investors: "Fjarfestar",
          manufacturers: "Framleidendur",
          admin: "Administrator",
          supervisor: "Supervisor"
        }
      },
      messagesPage: {
        conversationsLoadFailed: "Ekki toekst ad hlaa samtol.",
        messagesLoadFailed: "Ekki toekst ad hlaa skilabod.",
        pdfOnly: "Adeins PDF skrár eru leyfðar.",
        pdfTooLarge: "PDF er of stort (haemark 25MB).",
        sendFailed: "Ekki toekst ad senda skilabod.",
        downloadFailed: "Ekki toekst ad hala nedur vidhengi.",
        removedToast: "Samtali vid {{name}} var fjarlægt ur listanum thinum.",
        removeFailed: "Ekki toekst ad fjarlægja samtal.",
        title: "Skilabod",
        subtitle: "Thin samtol. Ef thu ert ekki med skilabod skaltu byrja a ad tengjast einhverjum.",
        searchPlaceholder: "Leita...",
        noResults: "Engar nidurstodur.",
        noConversations: "Engin samtol enn. Fardu i Connections og byrjaðu a skilabodum.",
        selectConversation: "Veldu samtal",
        chooseConversation: "Veldu samtal til ad hefja spjall.",
        selectFromLeft: "Veldu samtal til vinstri eda fardu i Connections til ad byrja nytt.",
        loadingMessages: "Hled skilabod...",
        you: "Thu",
        openPdf: "Opna PDF",
        attachPdf: "Baeta vid PDF",
        pdfOptional: "PDF valkvaett",
        writeMessage: "Skrifa skilabod...",
        selectConversationFirst: "Veldu fyrst samtal",
        removeTitle: "Fjarlægja samtal",
        removeMessage: "Fjarlægja samtal vid \"{{name}}\" ur listanum thinum?"
      },
      projects: {
        title: "Verkefni",
        subtitle: "Bua til eigin verkefni og skoda verkefni sem adrir hafa birt.",
        myProjects: "Min verkefni",
        exploreProjects: "Skoda verkefni",
        explore: "Skoda",
        newProject: "+ NÃ½tt verkefni",
        addProject: "Baeta vid verkefni",
        acronym: "Skammstofun",
        searchPlaceholder: "Leita...",
        noProjectsYet: "Engin verkefni enn.",
        noProjects: "Engin verkefni.",
        abstract: "Utdrattur",
        timeline: "Timalina:",
        extension: "Framlenging:",
        startDate: "Upphafsdagur",
        endDate: "Lokadagur",
        extensionEnd: "Mogulegur lokadagur framlengingar",
        contractNumber: "Samningsnumer",
        coordinator: "Samraemandi",
        partners: "SamstarfsaÃ°ilar",
        partner: "SamstarfsaÃ°ili",
        addPartner: "Baeta vid samstarfsaÃ°ila",
        removePartner: "FjarlÃ¦gja samstarfsaÃ°ila",
        deleteTitle: "Eyda verkefni",
        deleteMessage: "Eyda \"{{title}}\"? Ekki er haegt ad afturkalla Ã¾etta.",
        deleting: "EyÃ°i...",
        loadProfileFailed: "Ekki toekst ad hlaÃ°a profili.",
        viewProfile: "Syna profil"
      },
      publications: {
        title: "Birtingar",
        subtitle: "Baettu vid eigin birtingum og skodadu birtingar sem adrir hafa birt.",
        myPublications: "Minar birtingar",
        explore: "Skoda",
        newPublication: "+ Ny birting",
        searchPublications: "Leita i birtingum",
        searchPlaceholder: "Leita eftir titli, hofundum, timariti, DOI eda notanda...",
        noPublicationsYet: "Engar birtingar enn.",
        noResults: "Engar nidurstodur.",
        type: "Tegund",
        publicationTitle: "Titill",
        publicationTitlePlaceholder: "Titill birtingar",
        authors: "Hofundar",
        externalLink: "Ytri tengill",
        publicationDate: "Birtingardagur",
        year: "Ar",
        keywords: "Lykilord",
        journalConferenceTitle: "Titill timarits / radstefnu",
        journalConference: "Timarit / radstefna",
        volumeIssue: "Bindi / numer",
        pages: "SÃ­Ã°ur",
        doi: "DOI",
        publisher: "Utgefandi",
        pdfUpload: "PDF (max 10 MB)",
        replacePdf: "Skipta um PDF (max 10 MB)",
        openCurrentPdf: "Opna nuverandi PDF",
        saved: "Birting vistud.",
        saveFailed: "Ekki toekst ad vista birtingu.",
        updated: "Birting uppfaerd.",
        updateFailed: "Ekki toekst ad uppfaera birtingu.",
        deleted: "Birting eydd.",
        deleteFailed: "Ekki toekst ad eyda birtingu.",
        openPdfFailed: "Ekki toekst ad opna PDF.",
        loadFailed: "Ekki toekst ad hlaÃ°a birtingar.",
        profileLoadFailed: "Ekki toekst ad hlaÃ°a profili.",
        conversationFailed: "Ekki toekst ad hefja samtal.",
        deleteTitle: "Eyda birtingu",
        deleteAdminTitle: "Eyda birtingu (stjornandi)",
        deleteMessage: "Eyda \"{{title}}\"? Ekki er haegt ad afturkalla Ã¾etta.",
        deleting: "EyÃ°i...",
        titleRequired: "Titill er skyldubundinn.",
        yearInvalid: "Arid verdur ad vera a milli 1900 og 2100.",
        dateRequired: "Birtingardagur er skyldubundinn.",
        publisherRequired: "Utgefandi er skyldubundinn fyrir baekur/kafla.",
        journalRequired: "Titill timarits / radstefnu er skyldubundinn.",
        pdfTooLarge: "PDF ma vera haest 10 MB.",
        pdfOnly: "AÃ°eins PDF skra er leyfÃ°.",
        typeJournalArticle: "Timaritsgrein",
        typeConferencePaper: "Radstefnugrein",
        typeBook: "Bok",
        typeBookChapter: "Bokarkafli"
      }
    }
  }
} as const;

